import { Component, OnInit, OnDestroy, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { CodeValueConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeValueConversionMst.service';
import { GeneralSystemConstInfoMstService } from '../../../../../../sg-base/sg-base-shared/services/generalSystemConstInfoMst.service';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { MatSelectChange } from '@angular/material/select';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  FileInfo, ResponseCommon, Szza016aResponse, CodeConversionMstDto, CodeValueConversionMstDto, GeneralSystemConstInfoCacheDto, Sgkb575aRequest,
  Sgkb575aResCommonAceptSearchResultDto, Sgkb575aResFtiGoods, Sgkb575aResUserInfo, Sgkb575aResTurnonWorkInfo, Sgkb121aReqFtiGoodsInfoDto, Sgkb575aResCtrTankaDto, Sgkb121aReqFtiGoodsDto, Sgkb121aReqCtrDiscntsDto,
  Sgkb121aReqCtrTankaInfoDto, Sgkb121aReqCtrTankaDto, Szma301aRequest, Szma301aCustomResponse, Szma301aResponseGasCtrSearchResultDto, Sgkb502aRequest, Sgkd036aRequest,
  Szme004aRequest, Szoa104aRequest, Szoa104aCustomResponse, Szoa104aResponseVisitSearchResultDetailDto, Szoa109aRequest, Szoa109aResponsePrdSearchResultDto,
  Szoa110aRequest, Sgkb121aRequest, Sgkz011aRequest
} from 'sg-api';
import { UsedSgkb122dSgkb575aService } from '../../../sgkb122d/services/used-sgkb122d-sgkb575a.service';
import { UsedSgkb122dSzma301aService } from '../../../sgkb122d/services/used-sgkb122d-szma301a.service';
import { UsedSgkb122dSgkb502aService } from '../../../sgkb122d/services/used-sgkb122d-sgkb502a.service';
import { UsedSgkb122dSgkd036aService } from '../../../sgkb122d/services/used-sgkb122d-sgkd036a.service';
import { UsedSgkb122dSzme004aService } from '../../../sgkb122d/services/used-sgkb122d-szme004a.service';
import { UsedSgkb122dSzoa104aService } from '../../../sgkb122d/services/used-sgkb122d-szoa104a.service';
import { UsedSgkb122dSzoa109aService } from '../../../sgkb122d/services/used-sgkb122d-szoa109a.service';
import { UsedSgkb122dSzoa110aService } from '../../../sgkb122d/services/used-sgkb122d-szoa110a.service';
import { UsedSgkb122dSzza006aService } from '../../../sgkb122d/services/used-sgkb122d-szza006a.service';
import { UsedSgkb122dSgkb121aService } from '../../../sgkb122d/services/used-sgkb122d-sgkb121a.service';
import { UsedSgkb122dSgkz011aService } from '../../../sgkb122d/services/used-sgkb122d-sgkz011a.service';
import { Futai } from '../../../../../sg-kb-shared/models/futai.model';
import { FutaiGoodsInfo } from '../../models/futaiGoodsInfo';
import { FutaiGoods } from '../../models/futaiGoods';
import { CtrDiscnts } from '../../models/ctrDiscnts';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { SelectBox, UsedSgkz011aService } from 'cbc-shared-lib';
import { SgkbConstains } from '../../../../../sg-kb-shared/sg-kb-constans';

@Component({
  selector: 'app-sgkb122d',
  templateUrl: './sgkb122d.component.html',
  styleUrl: './sgkb122d.component.scss',
  animations: [
    trigger('openClose', [
      state('open', style({ height: '*', opacity: 1, overflow: 'hidden' })),
      state('closed', style({ height: '0', opacity: 0, overflow: 'hidden' })),
      transition('open <=> closed', [
        animate('500ms cubic-bezier(0.25, 0.8, 0.25, 1)')
      ])
    ])
  ]
})
export class Sgkb122dComponent implements OnInit, OnDestroy, AfterViewInit {
  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  // 契約情報
  /** 画面項目：名義（漢字） */
  name: string = null;
  /** 画面項目：名義（カナ） */
  nameKana: string = null;

  /** 画面項目：契約者情報変更有無 */
  ctrInfoChgUmu: UntypedFormControl =
    new UntypedFormControl({ value: false, disabled: false });

  /** 画面項目：変更後　名義（漢字） */
  aftName: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　名義（カナ） */
  aftNameKana: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });

  /** 画面項目：契約者電話番号１ */
  befCtrperTelNo1: string = null;
  /** 画面項目：変更後　契約者電話番号１ */
  aftCtrperTelNo1: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　契約者電話番号区分１ */
  aftCtrperTelNoDivList1: SelectBox[] = [];
  /** 画面項目：変更後　契約者電話番号区分１（選択値） */
  selectedAftCtrperTelNoDiv1: SelectBox = { value: '', viewValue: '' };
  /** 画面項目：契約者電話番号２ */
  befCtrperTelNo2: string = null;
  /** 画面項目：変更後　契約者電話番号２ */
  aftCtrperTelNo2: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　契約者電話番号区分２ */
  aftCtrperTelNoDivList2: SelectBox[] = [];
  /** 画面項目：変更後　契約者電話番号区分２（選択値） */
  selectedAftCtrperTelNoDiv2: SelectBox = { value: '', viewValue: '' };
  /** 画面項目：契約者電話番号３ */
  befCtrperTelNo3: string = null;
  /** 画面項目：変更後　契約者電話番号３ */
  aftCtrperTelNo3: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　契約者電話番号区分３ */
  aftCtrperTelNoDivList3: SelectBox[] = [];
  /** 画面項目：変更後　契約者電話番号区分３（選択値） */
  selectedAftCtrperTelNoDiv3: SelectBox = { value: '', viewValue: '' };

  /** 画面項目：契約者と同じ */
  isSameKeiyaku: UntypedFormControl =
    new UntypedFormControl({ value: false, disabled: false });

  /** 画面項目：使用者名義（漢字） */
  userName: string = null;
  /** 画面項目：使用者名義（カナ） */
  userNameKana: string = null;
  /** 画面項目：変更後　使用者名義（漢字） */
  aftUserName: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　使用者名義（カナ） */
  aftUserNameKana: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });

  /** 画面項目：使用者電話番号１ */
  befUserTelNo1: string = null;
  /** 画面項目：変更後　使用者電話番号１ */
  aftUserTelNo1: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　使用者電話番号区分１ */
  aftUserTelNoDivList1: SelectBox[] = [];
  /** 画面項目：変更後　使用者電話番号区分１（選択値） */
  selectedAftUserTelNoDiv1: SelectBox = { value: '', viewValue: '' };
  /** 画面項目：使用者電話番号２ */
  befUserTelNo2: string = null;
  /** 画面項目：変更後　使用者電話番号２ */
  aftUserTelNo2: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　使用者電話番号区分２ */
  aftUserTelNoDivList2: SelectBox[] = [];
  /** 画面項目：変更後　使用者電話番号区分２（選択値） */
  selectedAftUserTelNoDiv2: SelectBox = { value: '', viewValue: '' };
  /** 画面項目：使用者電話番号３ */
  befUserTelNo3: string = null;
  /** 画面項目：変更後　使用者電話番号３ */
  aftUserTelNo3: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false });
  /** 画面項目：変更後　使用者電話番号区分３ */
  aftUserTelNoDivList3: SelectBox[] = [];
  /** 画面項目：変更後　使用者電話番号区分３（選択値） */
  selectedAftUserTelNoDiv3: SelectBox = { value: '', viewValue: '' };

  /** 画面項目：支払方法 */
  payMethod: string = null;
  /** 画面項目：業種 */
  gyoshu: string;
  /** 画面項目：電気契約の案内 */
  electricityContractAnnai: string;

  // プラン選択
  /** 画面項目：お得なガス料金プランはこちら */
  bargainGasPricePlans: string;
  /** 画面項目：重要事項説明 共通事項 */
  importantItemUrl: string;
  /** 画面項目：料金プランリスト */
  pricePlanList: SelectBox[] = [];
  /** 画面項目：料金プラン（選択値） */
  selectedPricePlan: SelectBox = {
    value: '',
    viewValue: ''
  };
  /** 画面項目：付帯契約リスト */
  ftiContractList: Futai[] = [];
  /** 画面項目：付帯契約（選択値） */
  selectedFtiContract: Futai = {
    prdCode: '',
    goodsCode: '',
    goodsDispAname: ''
  };
  /** 画面項目：公団床暖房の申込書受領 */
  publicCorporationFloorHeatingSrndocReceipt: UntypedFormControl =
    new UntypedFormControl({ value: null, disabled: false });

  // 署名
  /** 画面項目：重要事項の説明 */
  importantMatterExplanation: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false }, [Validators.requiredTrue]);
  /** 画面項目：ガスの安全使用に関する説明 */
  gasSafeUseExplanation: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false }, [Validators.requiredTrue]);
  /** 画面項目：マイコンメータの説明 */
  maiconMeterExplanation: UntypedFormControl =
    new UntypedFormControl({ value: '', disabled: false }, [Validators.requiredTrue]);
  /** 画面項目：署名区分 */
  signatureDiv: UntypedFormControl =
    new UntypedFormControl({ value: '1', disabled: false }, Validators.required);
  /** 画面項目：開栓作業担当社員番号 */
  turnonWorkchargeStafno: string = null;
  /** 画面項目：開栓作業担当社員名 */
  turnonWorkchargeStafName: string = null;

  // 担当者記載欄
  /** 画面項目：手続き完了おしらせ直送不可 */
  procedureCompletionNoticeDeliveryNotPossible: UntypedFormControl =
    new UntypedFormControl({ value: false, disabled: false });
  /** 画面項目：手続き完了おしらせ紙希望 */
  procedureCompletionNoticePaperHope: UntypedFormControl =
    new UntypedFormControl({ value: false, disabled: false });
  /** 画面項目：センター要確認 */
  pricePlanNeedConfirm: UntypedFormControl =
    new UntypedFormControl({ value: false, disabled: false });
  /** 画面項目：作業者メモ */
  vstinfMemo: UntypedFormControl =
    new UntypedFormControl({ value: null, disabled: false });

  /** 非表示項目：業種 */
  hiddenGyoshu: string;
  /** 非表示項目：ログイン情報.社員番号 */
  usrId: string = "";
  /** 非表示項目：ＵＬ内部ファイル名 */
  uploadInternalFileName: string = null;
  /** 非表示項目：内部お客さま番号 */
  visitNo: string;
  /** 非表示項目：契約お客さま番号 */
  firstSrvctrNo: string;
  /** 非表示項目：請求お客さま番号 */
  recptFixNo: string;
  /** 非表示項目：会社コード */
  companycode: string;
  /** 非表示項目：登録ステータス */
  registrationstatus: string;
  /** 非表示項目：エネルギー種別コード */
  energyClscode: string;
  /** 非表示項目：販売形態コード */
  salfrmCode: string;
  /** 非表示項目：受付時プロダクトコード */
  prdCodeAtTimeAcept: string;
  /** 非表示項目：受付時プロダクトコード名称 */
  prdCodeAnameAtTimeAcept: string;
  /** 非表示項目：自用フラグ */
  selfuseFlg: string;
  /** 非表示項目：取次契約詳細コード */
  agencyontractSyosaicode: string;
  /** 非表示項目：導管事業者申請受付番号 */
  doknjgyshAppAcceptancenumber: string;
  /** 非表示項目：受付番号 */
  aceptNo: string;
  /** 非表示項目：受付履歴番号 */
  aceptRrkno: string;
  /** 非表示項目：更新通番号 */
  updateSrno: string;
  /** 非表示項目：ガス供給地点特定番号 */
  gasSuppntSpno: string;
  /** 非表示項目：総合供給先番号 */
  sougouSupplyDestinationNo: string;
  /** 非表示項目：プロダクト種別区分 */
  prdClsfyDivList: string[];
  /** 非表示項目：表示可能付帯商品コードリスト */
  displayableFtiGoodsCodeList: string[] = [];
  /** 非表示項目：付帯商品契約情報（共通受付照会APIレスポンス情報） */
  ftiGoodsInfoForCmnAceptSearchRes: Sgkb121aReqFtiGoodsInfoDto = {
    ftiGoodsList: []
  };
  /** 非表示項目：契約単価情報 */
  ctrTankaInfo: Sgkb121aReqCtrTankaInfoDto = null;
  /** 非表示項目：付帯商品情報 */
  futaiGoodsInfo: FutaiGoodsInfo = {
    futaiGoodsList: []
  };
  /** 非表示項目：付帯契約リスト(全量) */
  ftiContractListForAll: Futai[] = [];
  /** 非表示項目：申込方法 */
  srnMethod: string;
  /** 非表示項目：プロダクト種別区分コードマップ */
  prdClsfyDivCodeMap: Map<string, string> = new Map();
  /** 非表示項目：開栓種別コード */
  turnonClscode;
  /** 非表示項目：使用需要者区分（変更前） */
  befUsingjyuyoshaDiv: string;

  /** 画面間パラメータ：業種 */
  displayParamGyoshu: string;

  /** 画面制御用：料金プラン */
  pricePlanForDisplayControl: UntypedFormControl =
    new UntypedFormControl({ value: "", disabled: false }, Validators.required);
  /** 画面制御用：付帯契約 */
  ftiContractForDisplayControl: UntypedFormControl =
    new UntypedFormControl({ value: "", disabled: false });
  /** 画面制御用：署名コンポーネント表示 */
  isVisibleSignatureComponent: boolean = true;
  /** 画面制御用：開栓結果登録済フラグ */
  opentapresultRegistrationflag: string;
  /** 画面制御用：公団床暖房の申込書受領表示 */
  isVisiblePublicCorporationFloorHeatingSrndocReceipt: boolean = false;
  /** 画面制御用：電気契約の案内表示 */
  isVisibleElectricityContractAnnai: boolean = true;
  /** 画面制御用：お得なガス料金プランはこちら表示 */
  isVisibleBargainGasPricePlans: boolean = true;
  /** 画面制御用：署名拒否ラジオボタン表示 */
  isVisibleRefusedSign: boolean = false;
  /** 画面制御用：担当者記載欄表示 */
  isVisibleTantoushaComponent: boolean = true;
  /** 画面制御用：手続き完了おしらせ直送不可表示 */
  isVisibleProcedureCompletionNoticeDeliveryNotPossible: boolean = true;
  /** 画面制御用：手続き完了おしらせ紙希望表示 */
  isVisibleProcedureCompletionNoticePaperHope: boolean = true;
  /** 画面制御用：センター要確認表示 */
  isVisiblePricePlanNeedConfirm: boolean = true;
  /** 画面制御用：開栓作業担当者表示 */
  isVisibleTurnOnStaf: boolean = true;
  /** 画面制御用：エラー発生 */
  hasError: boolean = false;
  /** メッセージ出力制御用：エラー出力済フラグ */
  isOutputError: boolean = false;

  /** 契約者情報変更フォームグループ */
  ctrInfoChgFormGroup = new UntypedFormGroup({
    ctrInfoChgUmu: this.ctrInfoChgUmu,
    aftName: this.aftName,
    aftNameKana: this.aftNameKana,
    aftCtrperTelNo1: this.aftCtrperTelNo1,
    aftCtrperTelNo2: this.aftCtrperTelNo2,
    aftCtrperTelNo3: this.aftCtrperTelNo3
  });
  /** 使用者情報変更フォームグループ */
  userInfoChgFormGroup = new UntypedFormGroup({
    isSameKeiyaku: this.isSameKeiyaku,
    aftUserName: this.aftUserName,
    aftUserNameKana: this.aftUserNameKana,
    aftUserTelNo1: this.aftUserTelNo1,
    aftUserTelNo2: this.aftUserTelNo2,
    aftUserTelNo3: this.aftUserTelNo3
  });
  /** プラン選択フォームグループ */
  planSelectFormGroup = new UntypedFormGroup({
    pricePlanForDisplayControl: this.pricePlanForDisplayControl,
    ftiContractForDisplayControl: this.ftiContractForDisplayControl,
    publicCorporationFloorHeatingSrndocReceipt: this.publicCorporationFloorHeatingSrndocReceipt,
  });
  /** 署名フォームグループ */
  signatureFormGroup = new UntypedFormGroup({
    importantMatterExplanation: this.importantMatterExplanation,
    gasSafeUseExplanation: this.gasSafeUseExplanation,
    maiconMeterExplanation: this.maiconMeterExplanation,
    signatureDiv: this.signatureDiv,
  });
  /** 担当者記載欄フォームグループ */
  tantoushaFormGroup = new UntypedFormGroup({
    procedureCompletionNoticeDeliveryNotPossible: this.procedureCompletionNoticeDeliveryNotPossible,
    procedureCompletionNoticePaperHope: this.procedureCompletionNoticePaperHope,
    pricePlanNeedConfirm: this.pricePlanNeedConfirm,
    vstinfMemo: this.vstinfMemo,
  });
  /** 必須チェック対象項目グループ */
  requiredCheckItemGroup = new UntypedFormGroup({
    pricePlanForDisplayControl: this.pricePlanForDisplayControl,
    publicCorporationFloorHeatingSrndocReceipt: this.publicCorporationFloorHeatingSrndocReceipt,
    importantMatterExplanation: this.importantMatterExplanation,
    gasSafeUseExplanation: this.gasSafeUseExplanation,
    maiconMeterExplanation: this.maiconMeterExplanation,
  });

  /** コード変換マスタマップ */
  private codeConversionMstMap: Map<string, Array<CodeConversionMstDto>>;
  /** コード値変換マスタマップ */
  private codeValueConversionMstMap: Map<string, Array<CodeValueConversionMstDto>>;
  /** コード値変換マスタDtoリスト */
  private codeValueConversionMstDtoList: CodeValueConversionMstDto[];
  /** 汎用システム定数情報マスタマップ */
  private generalSystemConstInfoMstMap: Map<string, Array<GeneralSystemConstInfoCacheDto>>;

  /** コード変換画面項目ＩＤ：電話番号コード */
  private displayItemIdC000010: string = 'C000010';
  /** コード変換画面項目ＩＤ：ガス業種小分類 */
  private displayItemIdS000690: string = 'S000690';

  /** コード値変換識別種別：お得なガス料金プランURLキー */
  private discrmClsCodeSgkb011: string = 'SGKB011';
  /** コード値変換識別種別：共通重要事項URLキー */
  private discrmClsCodeSgkb012: string = 'SGKB012';
  /** コード値変換識別種別：プロダクト種別区分コードキー */
  private discrmClsCodeSgkb014: string = 'SGKB014';
  /** コード値変換識別種別：プロダクトコードキー */
  private discrmClsCodeSgkb017: string = 'SGKB017';

  /** 汎用システム定数コード：小売開栓結果登録画面で表示可能な付帯商品コード定義 */
  private sysDefCodeSgkb0004: string = 'SGKB0004';

  /** ＵＬファイル種別：ガス小売開栓結果署名ファイル */
  private ulFileType00009: string = '00009';

  /** 会社コード：西部ガス */
  static readonly SAIBU_GAS = "00001";
  /** 業種：公団対象リスト（公団分譲、公団の賃貸住宅） */
  static readonly KOUDAN_LIST = ["113", "144"];
  /** 料金プラン：床暖房契約（ホットメリット） */
  static readonly FLOOR_HEATING_CTR = "AAC03";

  /** 敬称：様 */
  private keishou: string = '　様';
  /** 警告メッセージ（業種と料金プランの整合性チェック） */
  private warnMsgForchkIntegrityGyoshuAndPlan: string = '選択された料金プランと業種が一致しません。\n正しい業種を作業者メモ欄に入力してください。';

  @Output() errorMessageModelArray: Array<SgAriaMessage>;
  @Output() onRegisterEvent = new EventEmitter<void>();

  constructor(
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private codeConversionMstService: CodeConversionMstService,
    private codeValueConversionMstService: CodeValueConversionMstService,
    private generalSystemConstInfoMstService: GeneralSystemConstInfoMstService,
    private usedSgkz011aService: UsedSgkz011aService,
    private usedSgkb122dSgkb575aService: UsedSgkb122dSgkb575aService,
    private usedSgkb122dSzma301aService: UsedSgkb122dSzma301aService,
    private usedSgkb122dSgkb502aService: UsedSgkb122dSgkb502aService,
    private usedSgkb122dSgkd036aService: UsedSgkb122dSgkd036aService,
    private usedSgkb122dSzme004aService: UsedSgkb122dSzme004aService,
    private usedSgkb122dSzoa104aService: UsedSgkb122dSzoa104aService,
    private usedSgkb122dSzoa109aService: UsedSgkb122dSzoa109aService,
    private usedSgkb122dSzoa110aService: UsedSgkb122dSzoa110aService,
    private usedSgkb122dSzza006aService: UsedSgkb122dSzza006aService,
    private usedSgkb122dSgkb121aService: UsedSgkb122dSgkb121aService,
    private usedSgkb122dSgkz011aService: UsedSgkb122dSgkz011aService,
  ) {
    // 画面間パラメータ取得
    this.hiddenGyoshu = this.route.snapshot.paramMap.get('gyoshu');
    this.displayParamGyoshu = this.route.snapshot.paramMap.get('gyoshu');
    this.doknjgyshAppAcceptancenumber = this.route.snapshot.paramMap.get('aceptNo');
  }

  /**
   * 初期処理
   * @memberof Sgkb122dComponent
   */
  ngOnInit(): void {
    // ログイン情報.社員番号取得
    this.usedSgkz011aService.updateUserInfo();
    this.usedSgkz011aService.userId.pipe(takeUntil(this.onDestroy$)).subscribe(userId => {
      this.usrId = userId;
    });

    // コード変換マスタマップ取得
    this.codeConversionMstService.getCodeConversionMst([
      this.displayItemIdC000010,
      this.displayItemIdS000690
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.codeConversionMstMap = data;
      });

    // コード値変換マスタマップ取得
    this.codeValueConversionMstService.getCodeValueConversionMst([
      this.discrmClsCodeSgkb011,
      this.discrmClsCodeSgkb012,
      this.discrmClsCodeSgkb014,
      this.discrmClsCodeSgkb017
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.codeValueConversionMstMap = data;
      });

    // 汎用システム定数情報マスタマップ取得
    this.generalSystemConstInfoMstService.getGeneralSystemConstInfoMst([
      this.sysDefCodeSgkb0004
    ])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.generalSystemConstInfoMstMap = data;
      });

    // 共通受付照会リクエスト（受付番号）設定
    const sgkb575aRequestForSearchAceptNo: Sgkb575aRequest = {
      aceptSearchInfo: {
        // 受付番号
        aceptNo: null,
        // 導管事業者申請受付番号
        doknjgyshAppAcceptancenumber: this.doknjgyshAppAcceptancenumber,
        // 受付履歴表示フラグ
        acceptancerirekiHyojiFlg: false,
      }
    };

    // 共通受付照会レスポンス（受付番号）取得
    this.usedSgkb122dSgkb575aService.searchContractor(sgkb575aRequestForSearchAceptNo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(sgkb575aResponseForSearchAceptNo => {
        // 共通受付照会レスポンス（受付番号）.共通受付照会結果リストから共通受付照会結果（受付番号）を取得
        let commonAceptSearchResultForSearchAceptNo = sgkb575aResponseForSearchAceptNo.commonAceptSearchResultList[0];
        // 登録ステータスが「一時保存」または、「取消」の場合
        if (commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.registrationstatus === SgkbConstains.CODE.REGIST_STATUS.TEMPSAVE ||
          commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.registrationstatus === SgkbConstains.CODE.REGIST_STATUS.CANCEL) {
          // エラーメッセージを表示する
          let registrationstatusAname = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.registrationstatusAname;
          let message = "受付状態が" + registrationstatusAname + "のため、小売開栓結果登録ができません";
          this.errorHandlingForInit(message);
        }

        // 共通受付照会結果（受付番号）を画面項目に設定
        this.setCtrperInfoFromSgkb575a(commonAceptSearchResultForSearchAceptNo);
        this.setUserInfo(commonAceptSearchResultForSearchAceptNo);
        this.setTurnonWorkchargeStaf(commonAceptSearchResultForSearchAceptNo);
        // 電話番号区分リストの設定
        this.setTelNoDivList();
        // 「電気契約の案内」を設定
        this.electricityContractAnnai = commonAceptSearchResultForSearchAceptNo.gasConInfo.electricitycontractAnnaianame;

        // 汎用システム定数情報マスタマップから小売開栓結果登録画面で表示可能な付帯商品コード定義に紐づく汎用システム定数情報Dtoリストを取得
        let generalSystemConstInfoDtoList: GeneralSystemConstInfoCacheDto[] = this.generalSystemConstInfoMstMap.get(this.sysDefCodeSgkb0004);
        // 汎用システム定数情報Dtoリストからシステム定数設定値テキスト（＝表示可能付帯商品コード）のみを抽出し、表示可能付帯商品コードリストに設定
        this.displayableFtiGoodsCodeList = generalSystemConstInfoDtoList.map(dto => dto.settingValueText);

        // 付帯商品契約情報が設定されている、かつ付帯商品契約リストが設定されている場合
        if (commonAceptSearchResultForSearchAceptNo.ftiGoodsInfo != null && commonAceptSearchResultForSearchAceptNo.ftiGoodsInfo.ftiGoodsList != null) {
          // 「表示可能付帯商品コードリスト」の商品コードと一致する「受付情報．付帯商品契約情報．付帯商品契約リスト．付帯商品契約」を「表示可能付帯商品契約リスト」として取得
          let displayableFtiGoodsList: Sgkb575aResFtiGoods[] =
            commonAceptSearchResultForSearchAceptNo.ftiGoodsInfo.ftiGoodsList.filter(ftiGoods => this.displayableFtiGoodsCodeList.includes(ftiGoods.goodsCode));
          // 「表示可能付帯商品契約リスト」が設定されている場合
          if (displayableFtiGoodsList != null) {
            this.setFtiContractList(displayableFtiGoodsList, commonAceptSearchResultForSearchAceptNo.ctrCommonInfo.prdCode);
          }
          // 「表示可能付帯商品コードリスト」の商品コードと一致しない「受付情報．付帯商品契約情報．付帯商品契約リスト．付帯商品契約」を「表示不可付帯商品契約リスト」として取得
          let notDisplayableFtiGoodsList: Sgkb575aResFtiGoods[] =
            commonAceptSearchResultForSearchAceptNo.ftiGoodsInfo.ftiGoodsList.filter(ftiGoods => !this.displayableFtiGoodsCodeList.includes(ftiGoods.goodsCode));
          // 「表示不可付帯商品契約リスト」が設定されている場合
          if (notDisplayableFtiGoodsList != null) {
            this.setFtiGoodsInfo(notDisplayableFtiGoodsList);
          }
        }
        // 手続き完了おしらせ直送可否フラグが「不可」の場合
        if (commonAceptSearchResultForSearchAceptNo.srnInfo.procedurecompletionNoticeDeliverypossibility === SgkbConstains.CODE.TETSUZUKI_COMP_NTC_DRT_KAHI_FLG.NONEED) {
          // 画面項目：手続き完了おしらせ直送不可のチェックを入れる
          this.procedureCompletionNoticeDeliveryNotPossible.setValue(true);
        }
        // 契約手続き完了通知紙希望フラグが「希望あり」の場合
        if (commonAceptSearchResultForSearchAceptNo.srnInfo.ctrProcedurecompletionPaperhopeflag === SgkbConstains.CODE.CNTRCT_TETSUZUKI_CMP_NTC_PAPER_FLG.PREF) {
          // 画面項目：手続き完了おしらせ紙希望のチェックを入れる
          this.procedureCompletionNoticePaperHope.setValue(true);
        }
        // センター要確認フラグが「要」の場合
        if (commonAceptSearchResultForSearchAceptNo.gasConInfo.priceplanNeedconfirmflag === SgkbConstains.CODE.FEE_PLAN_CONFIRM_FLG.NEED) {
          // 画面項目：センター要確認のチェックを入れる
          this.pricePlanNeedConfirm.setValue(true);
        }
        this.vstinfMemo.setValue(commonAceptSearchResultForSearchAceptNo.gasConInfo.vstinfMemo);

        // 共通受付照会結果（受付番号）を非表示項目に設定
        this.visitNo = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.visitNo;
        this.firstSrvctrNo = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.firstSrvctrNo;
        this.recptFixNo = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.recptFixNo;
        this.companycode = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.companycode;
        this.registrationstatus = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.registrationstatus;
        this.energyClscode = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.energyClscode;
        this.salfrmCode = commonAceptSearchResultForSearchAceptNo.ctrCommonInfo.salfrmCode;
        this.prdCodeAtTimeAcept = commonAceptSearchResultForSearchAceptNo.ctrCommonInfo.prdCode;
        this.prdCodeAnameAtTimeAcept = commonAceptSearchResultForSearchAceptNo.ctrCommonInfo.prdCodeAname;
        this.selfuseFlg = commonAceptSearchResultForSearchAceptNo.ctrCommonInfo.selfuseFlg;
        this.aceptNo = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.aceptNo;
        this.aceptRrkno = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.aceptRrkno;
        this.updateSrno = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.updateSrno;
        this.gasSuppntSpno = commonAceptSearchResultForSearchAceptNo.gasConInfo.gasSuppntSpno;
        this.turnonClscode = commonAceptSearchResultForSearchAceptNo.gasProvisionacceptanceInfo.turnonClscode;

        let aceptClsfy = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.aceptClsfy;
        // 受付種別コードが「ガス総合契約開始」の場合
        if (aceptClsfy === SgkbConstains.CODE.ACEPT_CLY_CD.GAS_SOUGOU_CTR_START) {
          this.sougouSupplyDestinationNo = commonAceptSearchResultForSearchAceptNo.gasConInfo.gasSuppntSpno;
        }
        // レスポンスの契約単価情報が設定されている、かつ
        // 契約単価リストが設定されている、かつ
        // 契約単価リストが空でない場合
        if (commonAceptSearchResultForSearchAceptNo.ctrTankaInfo != null &&
          commonAceptSearchResultForSearchAceptNo.ctrTankaInfo.ctrTankaList != null &&
          commonAceptSearchResultForSearchAceptNo.ctrTankaInfo.ctrTankaList.length > 0) {
          this.setCtrTankaMstList(commonAceptSearchResultForSearchAceptNo.ctrTankaInfo.ctrTankaList);
          this.ctrTankaInfo.premiumTanka = commonAceptSearchResultForSearchAceptNo.gasConInfo.premiumTanka;
        }
        this.srnMethod = commonAceptSearchResultForSearchAceptNo.srnInfo.srnMethod;

        // 受付種別コードが「ガス開栓」または「ガス総合契約開始」の場合
        if (aceptClsfy === SgkbConstains.CODE.ACEPT_CLY_CD.GAS_OPEN || aceptClsfy === SgkbConstains.CODE.ACEPT_CLY_CD.GAS_SOUGOU_CTR_START) {
          // 支払方法を設定する
          this.setPayMethod(commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.aceptNo);
        }

        // 自用フラグがtrueの場合
        if (this.selfuseFlg === SgkbConstains.CODE.JIYOU_FLG.JIYOU) {
          // 料金プランを非活性にする
          this.planSelectFormGroup.controls["pricePlanForDisplayControl"].disable();
          // 付帯契約を非活性にする
          this.planSelectFormGroup.controls["ftiContractForDisplayControl"].disable();
          // 手続き完了お知らせ直送不可を非活性にする
          this.tantoushaFormGroup.controls["procedureCompletionNoticeDeliveryNotPossible"].disable();
          // センター要確認を非表示にし、センター要確認の値をnullにする
          this.isVisiblePricePlanNeedConfirm = false;
          this.pricePlanNeedConfirm.setValue(null);
        }
        // 入居前点検、空き家修繕工事の場合
        if (this.turnonClscode === SgkbConstains.CODE.TURN_ON_CLS_CODE.PRECHECK ||
          this.turnonClscode === SgkbConstains.CODE.TURN_ON_CLS_CODE.VACANTREPAIR) {
          // 料金プランを非活性にする
          this.planSelectFormGroup.controls["pricePlanForDisplayControl"].disable();
          // 付帯契約を非活性にする
          this.planSelectFormGroup.controls["ftiContractForDisplayControl"].disable();
        }
        // 申込方法が「Ｗｅｂ（直接）」以外の場合
        if (this.srnMethod != SgkbConstains.CODE.SRN_METHOD.WEB_DIRECT) {
          // 手続き完了おしらせ紙希望を非表示にし、手続き完了おしらせ紙希望の値をnullにする
          this.isVisibleProcedureCompletionNoticePaperHope = false;
          this.procedureCompletionNoticePaperHope.setValue(null);
        }
        // センター要確認後の変更（＝画面間パラメータの業種が設定されていない場合）
        if (this.displayParamGyoshu === null) {
          // 署名コンポーネントを非表示にする
          this.isVisibleSignatureComponent = false;
          // 画面項目：署名区分の値にnullを設定する
          this.signatureDiv.setValue(null);
          // 署名コンポーネントの項目を必須チェック対象外とする
          this.signatureFormGroup.controls["importantMatterExplanation"].clearValidators();
          this.signatureFormGroup.controls["importantMatterExplanation"].updateValueAndValidity();
          this.signatureFormGroup.controls["gasSafeUseExplanation"].clearValidators();
          this.signatureFormGroup.controls["gasSafeUseExplanation"].updateValueAndValidity();
          this.signatureFormGroup.controls["maiconMeterExplanation"].clearValidators();
          this.signatureFormGroup.controls["maiconMeterExplanation"].updateValueAndValidity();
        }

        // 開栓作業時（＝画面間パラメータの業種が設定されている場合）
        if (this.displayParamGyoshu != null) {
          // 画面項目：業種の設定
          this.setGyoshuForCodeConversion(this.hiddenGyoshu);
          // エネルギー種別コードが「都市ガス」の場合
          if (this.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.CITY_GAS) {
            // 「署名拒否」ラジオボタンを表示する
            this.isVisibleRefusedSign = true;
          }

          // 通常開栓の場合
          if (commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.firstSrvctrNo === null &&
            commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.ctrstrAcceptancenumber === null) {
            // エネルギー種別コードが「都市ガス」かつ、「ガス業種小分類」が100番台の業種の場合
            if (this.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.CITY_GAS && this.hiddenGyoshu.substring(0, 1) === "1") {
              // お得なガス料金プランURL設定
              this.setBargainGasPricePlans(this.companycode);
            } else {
              // お得なガス料金プランはこちらを非表示にする
              this.isVisibleBargainGasPricePlans = false;
            }
            // 重要事項説明 共通事項URL設定
            this.setImportantItemUrl(this.hiddenGyoshu);
            // 料金プランリスト・付帯契約リスト設定
            this.setPricePlanListAndFtiContractList();
            // 会社コードが西部ガスかつ業種が公団かつ料金プランが床暖房契約（ホットメリット）の場合
            if (Sgkb122dComponent.SAIBU_GAS === this.companycode &&
              Sgkb122dComponent.KOUDAN_LIST.includes(this.hiddenGyoshu) &&
              Sgkb122dComponent.FLOOR_HEATING_CTR === this.prdCodeAtTimeAcept) {
              // 公団床暖房の申込書受領を表示する
              this.isVisiblePublicCorporationFloorHeatingSrndocReceipt = true;
              this.publicCorporationFloorHeatingSrndocReceipt.setValidators([Validators.requiredTrue]);
              this.publicCorporationFloorHeatingSrndocReceipt.updateValueAndValidity();
            }
          }

          // 契約登録受付画面から登録した場合
          if (this.registrationstatus != null) {
            // 料金プランを非活性にする
            this.planSelectFormGroup.controls["pricePlanForDisplayControl"].disable();
            // 付帯契約を非活性にする
            this.planSelectFormGroup.controls["ftiContractForDisplayControl"].disable();
            // センター要確認を非表示にし、センター要確認の値をnullにする
            this.isVisiblePricePlanNeedConfirm = false;
            this.pricePlanNeedConfirm.setValue(null);
          }

          // 共通受付照会結果（受付番号）の契約お客さま番号に値が設定されている場合
          if (commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.firstSrvctrNo != null) {
            // 契約情報取得（ガス）リクエスト設定
            const szma301aRequest: Szma301aRequest = {
              ctrSearchInfo: {
                // サービス契約番号に共通受付照会結果（受付番号）の契約お客さま番号を設定
                srvCtrNo: commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.firstSrvctrNo,
              }
            };
            // 契約情報取得（ガス）レスポンス取得
            this.usedSgkb122dSzma301aService.searchContractor(szma301aRequest)
              .pipe(takeUntil(this.onDestroy$))
              .subscribe(szma301aResponse => {
                // 契約情報取得（ガス）結果が設定されていない場合
                if (szma301aResponse.gasCtrSearchResultDto === null) {
                  // エラーメッセージを表示する
                  let message = "ご指定の契約お客さま番号に紐づく契約が存在しません";
                  this.errorHandlingForInit(message);
                }
                // レスポンス共通を取得
                let responseCommon = szma301aResponse.responseCommon;
                // レスポンスカスタマイズエリアを取得
                let responseCustomize = <Szma301aCustomResponse>responseCommon.responseCustomize
                // 契約情報取得（ガス）結果を取得
                let gasCtrSearchResultDto = szma301aResponse.gasCtrSearchResultDto;
                // 契約情報取得（ガス）結果を画面項目に設定
                this.setCtrperInfoFromSmza301a(gasCtrSearchResultDto);
                // 契約情報取得（ガス）結果に付帯商品契約情報が設定されている、かつ付帯商品契約リストが設定されている場合
                if (gasCtrSearchResultDto.ftiGoodsMstInfo != null && gasCtrSearchResultDto.ftiGoodsMstInfo.ftiGoodsMstList != null) {
                  let fti: Futai = {
                    prdCode: gasCtrSearchResultDto.ctrCommonMstInfo.prdCode,
                    goodsCode: gasCtrSearchResultDto.ftiGoodsMstInfo.ftiGoodsMstList[0].goodsCode,
                    goodsDispAname: gasCtrSearchResultDto.ftiGoodsMstInfo.ftiGoodsMstList[0].prdGoodsAname
                  }
                  this.ftiContractList.push(fti);
                }
                // 契約情報取得（ガス）結果を非表示項目に設定
                this.visitNo = gasCtrSearchResultDto.ctrperMstInfo.visitNo;
                this.companycode = responseCustomize.ctrCommonInfo.companycode;
                this.salfrmCode = gasCtrSearchResultDto.ctrCommonMstInfo.salfrmCode;
                this.prdCodeAtTimeAcept = gasCtrSearchResultDto.ctrCommonMstInfo.prdCode;
                this.prdCodeAnameAtTimeAcept = gasCtrSearchResultDto.ctrCommonMstInfo.prdAname;
                this.sougouSupplyDestinationNo = responseCustomize.ctrCommonInfo.suppntSpno;

                // 画面項目：業種設定
                // 総合契約の場合
                if (this.sougouSupplyDestinationNo != null) {
                  this.setItemsFromGasEquipmentInfo(this.sougouSupplyDestinationNo);
                }
                // 非表示項目：請求お客さま番号の設定がある場合
                if (this.recptFixNo != null) {
                  // 請請求先・請求情報取得API呼び出し
                  this.callSzme004a();
                } else {
                  this.payMethod = "払込票";
                }
                // 開栓作業時に契約マスタが存在するということは、被総合開栓の2件目以降のため、以下の処理を行う
                // 受付時の料金プランを画面項目：料金プラン（選択値）に設定
                this.selectedPricePlan.value = this.prdCodeAtTimeAcept;
                this.selectedPricePlan.viewValue = this.prdCodeAnameAtTimeAcept;
                // 受付時の料金プランを画面項目：料金プランリストに設定する
                let pricePlan: SelectBox =
                {
                  value: this.prdCodeAtTimeAcept,
                  viewValue: this.prdCodeAnameAtTimeAcept
                };
                this.pricePlanList.push(pricePlan);
                // プロダクト種別区分コードマップにキー：プロダクトコード、バリュー：プロダクト種別区分コードを設定
                this.prdClsfyDivCodeMap.set(this.prdCodeAtTimeAcept, gasCtrSearchResultDto.ctrCommonMstInfo.prdClsfyDiv);
                // 電気契約の案内表示を非表示にする
                this.isVisibleElectricityContractAnnai = false;
                // 料金プランを非活性にする
                this.planSelectFormGroup.controls["pricePlanForDisplayControl"].disable();
                // 付帯契約を非活性にする
                this.planSelectFormGroup.controls["ftiContractForDisplayControl"].disable();
                // 重要事項の説明を選択状態にし、非活性にする
                this.signatureFormGroup.controls["importantMatterExplanation"].setValue(true);
                this.signatureFormGroup.controls["importantMatterExplanation"].disable();
                // 担当者記載欄を非表示にする
                this.isVisibleTantoushaComponent = false;
                // 手続き完了おしらせ直送不可の値をnullにする
                this.procedureCompletionNoticeDeliveryNotPossible.setValue(null);
                // 手続き完了おしらせ紙希望の値をnullにする
                this.procedureCompletionNoticePaperHope.setValue(null);
                // センター要確認の値をnullにする
                this.pricePlanNeedConfirm.setValue(null);
              });
          }

          // 共通受付照会結果（受付番号）の契約開始受付番号に値が設定されている場合
          if (commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.ctrstrAcceptancenumber != null) {
            // 共通受付照会リクエスト（契約開始番号）設定
            const sgkb575aRequestForSearchCtrStartNo: Sgkb575aRequest = {
              aceptSearchInfo: {
                // 受付番号に共通受付照会結果（受付番号）の契約開始受付番号を設定
                aceptNo: commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.ctrstrAcceptancenumber,
                // 導管事業者申請受付番号
                doknjgyshAppAcceptancenumber: null,
                // 受付履歴表示フラグ
                acceptancerirekiHyojiFlg: false,
              }
            };
            // 共通受付照会レスポンス（契約開始番号）取得
            this.usedSgkb122dSgkb575aService.searchContractor(sgkb575aRequestForSearchCtrStartNo)
              .pipe(takeUntil(this.onDestroy$))
              .subscribe(sgkb575aResponseForSearchCtrStartNo => {
                // 共通受付照会レスポンス（契約開始番号）.共通受付照会結果リストから共通受付照会結果（契約開始番号）を取得
                let commonAceptSearchResultForSearchCtrStartNo = sgkb575aResponseForSearchCtrStartNo.commonAceptSearchResultList[0];
                // 共通受付照会結果（契約開始番号）を画面項目に設定
                this.setCtrperInfoFromSgkb575a(commonAceptSearchResultForSearchCtrStartNo);
                this.electricityContractAnnai = commonAceptSearchResultForSearchCtrStartNo.gasConInfo.electricitycontractAnnaianame;
                // 手続き完了おしらせ直送可否フラグが「不可」の場合
                if (commonAceptSearchResultForSearchCtrStartNo.srnInfo.procedurecompletionNoticeDeliverypossibility ===
                  SgkbConstains.CODE.TETSUZUKI_COMP_NTC_DRT_KAHI_FLG.NONEED) {
                  // 画面項目：手続き完了おしらせ直送不可のチェックを入れる
                  this.procedureCompletionNoticeDeliveryNotPossible.setValue(true);
                }
                // 共通受付照会結果（契約開始番号）を非表示項目に設定
                this.visitNo = commonAceptSearchResultForSearchCtrStartNo.aceptCommonInfo.visitNo;
                this.recptFixNo = commonAceptSearchResultForSearchCtrStartNo.aceptCommonInfo.recptFixNo;
                this.companycode = commonAceptSearchResultForSearchCtrStartNo.aceptCommonInfo.companycode;
                this.registrationstatus = commonAceptSearchResultForSearchCtrStartNo.aceptCommonInfo.registrationstatus;
                this.energyClscode = commonAceptSearchResultForSearchCtrStartNo.aceptCommonInfo.energyClscode;
                this.salfrmCode = commonAceptSearchResultForSearchCtrStartNo.ctrCommonInfo.salfrmCode;
                this.prdCodeAtTimeAcept = commonAceptSearchResultForSearchCtrStartNo.ctrCommonInfo.prdCode;
                this.prdCodeAnameAtTimeAcept = commonAceptSearchResultForSearchCtrStartNo.ctrCommonInfo.prdCodeAname;
                this.selfuseFlg = commonAceptSearchResultForSearchCtrStartNo.ctrCommonInfo.selfuseFlg;
                this.opentapresultRegistrationflag = commonAceptSearchResultForSearchCtrStartNo.srnInfo.opentapresultRegistrationflag;
                // 開栓結果登録済フラグが「未登録」の場合
                if (commonAceptSearchResultForSearchCtrStartNo.srnInfo.opentapresultRegistrationflag ===
                  SgkbConstains.CODE.OPEN_RESULT_REGISTED_FLG.NOT_REGIST) {
                  this.updateSrno = commonAceptSearchResultForSearchCtrStartNo.aceptCommonInfo.updateSrno;
                }
                this.sougouSupplyDestinationNo = commonAceptSearchResultForSearchCtrStartNo.gasConInfo.gasSuppntSpno;
                // 付帯商品契約情報が設定されている、かつ付帯商品契約リストが設定されている場合
                if (commonAceptSearchResultForSearchCtrStartNo.ftiGoodsInfo != null
                  && commonAceptSearchResultForSearchCtrStartNo.ftiGoodsInfo.ftiGoodsList != null) {
                  // 「表示可能付帯商品コードリスト」の商品コードと一致する「受付情報．付帯商品契約情報．付帯商品契約リスト．付帯商品契約」を「表示可能付帯商品契約リスト」として取得
                  let displayableFtiGoodsList: Sgkb575aResFtiGoods[] =
                    commonAceptSearchResultForSearchCtrStartNo.ftiGoodsInfo.ftiGoodsList.filter(ftiGoods => this.displayableFtiGoodsCodeList.includes(ftiGoods.goodsCode));
                  // 「表示可能付帯商品契約リスト」が設定されている場合
                  if (displayableFtiGoodsList != null) {
                    this.setFtiContractList(displayableFtiGoodsList, commonAceptSearchResultForSearchCtrStartNo.ctrCommonInfo.prdCode);
                  }
                  // 「表示可能付帯商品コードリスト」の商品コードと一致しない「受付情報．付帯商品契約情報．付帯商品契約リスト．付帯商品契約」を「表示不可付帯商品契約リスト」として取得
                  let notDisplayableFtiGoodsList: Sgkb575aResFtiGoods[] =
                    commonAceptSearchResultForSearchCtrStartNo.ftiGoodsInfo.ftiGoodsList.filter(ftiGoods => !this.displayableFtiGoodsCodeList.includes(ftiGoods.goodsCode));
                  // 「表示不可付帯商品契約リスト」が設定されている場合
                  if (notDisplayableFtiGoodsList != null) {
                    this.setFtiGoodsInfo(notDisplayableFtiGoodsList);
                  }
                }
                // レスポンスの契約単価情報が設定されている、かつ
                // 契約単価リストが設定されている、かつ
                // 契約単価リストが空でない場合
                if (commonAceptSearchResultForSearchCtrStartNo.ctrTankaInfo != null &&
                  commonAceptSearchResultForSearchCtrStartNo.ctrTankaInfo.ctrTankaList != null &&
                  commonAceptSearchResultForSearchCtrStartNo.ctrTankaInfo.ctrTankaList.length > 0) {
                  this.setCtrTankaMstList(commonAceptSearchResultForSearchCtrStartNo.ctrTankaInfo.ctrTankaList);
                  this.ctrTankaInfo.premiumTanka = commonAceptSearchResultForSearchCtrStartNo.gasConInfo.premiumTanka;
                }

                let ctrstrAcceptancenumber = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.ctrstrAcceptancenumber;
                // 共通受付照会レスポンス（受付番号）の受付種別コードが「被総合開栓」かつ、契約開始受付番号が設定されている場合
                if (aceptClsfy === SgkbConstains.CODE.ACEPT_CLY_CD.HISOUGOU_OPEN && ctrstrAcceptancenumber != null) {
                  // 支払方法を設定する
                  this.setPayMethod(commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.aceptNo);
                }
                // 画面項目：業種の設定
                // 総合契約の場合
                if (this.sougouSupplyDestinationNo != null) {
                  this.setItemsFromGasEquipmentInfo(this.sougouSupplyDestinationNo);
                }

                // 画面制御条件
                // 被総合開栓の2件目以降の場合
                if (this.opentapresultRegistrationflag === SgkbConstains.CODE.OPEN_RESULT_REGISTED_FLG.REGISTED) {
                  // 電気契約の案内表示を非表示にする
                  this.isVisibleElectricityContractAnnai = false;
                  // 料金プランを非活性にする
                  this.planSelectFormGroup.controls["pricePlanForDisplayControl"].disable();
                  // 付帯契約を非活性にする
                  this.planSelectFormGroup.controls["ftiContractForDisplayControl"].disable();
                  // 重要事項の説明を選択状態にし、非活性にする
                  this.signatureFormGroup.controls["importantMatterExplanation"].setValue(true);
                  this.signatureFormGroup.controls["importantMatterExplanation"].disable();
                  // 担当者記載欄を非表示にする
                  this.isVisibleTantoushaComponent = false;
                  // 手続き完了おしらせ直送不可の値をnullにする
                  this.procedureCompletionNoticeDeliveryNotPossible.setValue(null);
                  // 手続き完了おしらせ紙希望の値をnullにする
                  this.procedureCompletionNoticePaperHope.setValue(null);
                  // センター要確認の値をnullにする
                  this.pricePlanNeedConfirm.setValue(null);
                }
                // 契約登録受付画面から登録した場合
                if (this.registrationstatus != null) {
                  // 料金プランを非活性にする
                  this.planSelectFormGroup.controls["pricePlanForDisplayControl"].disable();
                  // 付帯契約を非活性にする
                  this.planSelectFormGroup.controls["ftiContractForDisplayControl"].disable();
                  // センター要確認を非表示にし、センター要確認の値をnullにする
                  this.isVisiblePricePlanNeedConfirm = false;
                  this.pricePlanNeedConfirm.setValue(null);
                }
                // 自用フラグがtrueの場合
                if (this.selfuseFlg === SgkbConstains.CODE.JIYOU_FLG.JIYOU) {
                  // 料金プランを非活性にする
                  this.planSelectFormGroup.controls["pricePlanForDisplayControl"].disable();
                  // 付帯契約を非活性にする
                  this.planSelectFormGroup.controls["ftiContractForDisplayControl"].disable();
                  // 手続き完了お知らせ直送不可を非活性にする
                  this.tantoushaFormGroup.controls["procedureCompletionNoticeDeliveryNotPossible"].disable();
                  // センター要確認を非表示にし、手続き完了おしらせ紙希望の値をnullにする
                  this.isVisiblePricePlanNeedConfirm = false;
                  this.pricePlanNeedConfirm.setValue(null);
                }
                // エネルギー種別コードが「都市ガス」の場合
                if (this.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.CITY_GAS) {
                  // 「署名拒否」ラジオボタンを表示する
                  this.isVisibleRefusedSign = true;
                }
              });
          }
        } else {
          // センター要確認後の変更時（＝画面間パラメータの業種が設定されていない場合）

          // 共通受付照会結果（受付番号）の契約お客さま番号が設定されている場合
          if (commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.firstSrvctrNo != null) {
            // エラーメッセージを表示する
            let message = "契約が既に存在するため、契約変更で修正してください";
            this.errorHandlingForInit(message);
          }
          // 共通受付照会結果（受付番号）の初回小売開栓結果登録受付番号が設定されている場合
          if (commonAceptSearchResultForSearchAceptNo.gasConInfo.firstRetailkaisenresultresitorAcceptancenumber != null) {
            // 共通受付照会リクエスト（開栓結果番号）設定
            const sgkb575aRequestForSearchKaisenResultNo: Sgkb575aRequest = {
              aceptSearchInfo: {
                // 受付番号に共通受付照会結果（受付番号）の初回小売開栓結果登録受付番号を設定
                aceptNo: commonAceptSearchResultForSearchAceptNo.gasConInfo.firstRetailkaisenresultresitorAcceptancenumber,
                // 導管事業者申請受付番号
                doknjgyshAppAcceptancenumber: null,
                // 受付履歴表示フラグ
                acceptancerirekiHyojiFlg: false,
              }
            };
            // 共通受付照会レスポンス（開栓結果番号）取得
            this.usedSgkb122dSgkb575aService.searchContractor(sgkb575aRequestForSearchKaisenResultNo)
              .pipe(takeUntil(this.onDestroy$))
              .subscribe(sgkb575aResponseForSearchKaisenResultNo => {
                // 共通受付照会レスポンス（開栓結果番号）.共通受付照会結果リストから共通受付照会結果（開栓結果番号）を取得
                let commonAceptSearchResultForSearchKaisenResultNo =
                  sgkb575aResponseForSearchKaisenResultNo.commonAceptSearchResultList[0];
                // 登録ステータスが「取消」の場合
                if (commonAceptSearchResultForSearchKaisenResultNo.aceptCommonInfo.registrationstatus === SgkbConstains.CODE.REGIST_STATUS.CANCEL) {
                  // エラーメッセージを表示する
                  let registrationstatusAname = commonAceptSearchResultForSearchAceptNo.aceptCommonInfo.registrationstatusAname;
                  let message = "受付状態が" + registrationstatusAname + "のため、小売開栓結果登録ができません";
                  this.errorHandlingForInit(message);
                }
                // 共通受付照会結果（開栓結果番号）を画面項目に設定
                this.setUserInfo(commonAceptSearchResultForSearchKaisenResultNo);
                this.setTurnonWorkchargeStaf(commonAceptSearchResultForSearchKaisenResultNo);

                // 共通受付照会結果（開栓結果番号）を非表示項目に設定
                this.aceptNo = commonAceptSearchResultForSearchKaisenResultNo.aceptCommonInfo.aceptNo;
                this.aceptRrkno = commonAceptSearchResultForSearchKaisenResultNo.aceptCommonInfo.aceptRrkno;
                this.gasSuppntSpno = commonAceptSearchResultForSearchKaisenResultNo.gasConInfo.gasSuppntSpno;

                // 画面項目：業種の設定
                // 総合契約の場合
                if (this.sougouSupplyDestinationNo != null) {
                  this.setItemsFromGasEquipmentInfo(this.sougouSupplyDestinationNo);
                } else {
                  this.setItemsFromGasEquipmentInfo(this.gasSuppntSpno);
                }
              });
          } else {
            // 共通受付照会結果（受付番号）の初回小売開栓結果登録受付番号が設定されていない場合
            // 画面項目：業種の設定
            // 総合契約の場合
            if (this.sougouSupplyDestinationNo != null) {
              this.setItemsFromGasEquipmentInfo(this.sougouSupplyDestinationNo);
            } else {
              this.setItemsFromGasEquipmentInfo(this.gasSuppntSpno);
            }
          }
        }
      });
  }

  /**
   * 契約者情報を設定する（共通受付照会）
   * @memberof Sgkb122dComponent
   */
  setCtrperInfoFromSgkb575a(commonAceptSearchResult: Sgkb575aResCommonAceptSearchResultDto): void {

    // 開栓作業時情報
    let turnonWorkInfo: Sgkb575aResTurnonWorkInfo = {};
    if (commonAceptSearchResult.turnonWorkInfo != null) {
      turnonWorkInfo = commonAceptSearchResult.turnonWorkInfo;
    }

    // 契約者情報変更有無
    if (turnonWorkInfo.ctrperinfoChangeyesnoFlg == SgkbConstains.CODE.CTRPERINFO_CHANGEYESNO_FLG.CHANGE) {
      this.ctrInfoChgUmu.setValue(true);
    }
    // 変更後　名義（漢字）
    this.aftName.setValue(turnonWorkInfo.afCtrperKnjnm);
    // 変更後　名義（カナ）
    this.aftNameKana.setValue(turnonWorkInfo.afCtrperKananame);
    // 変更後　契約者電話番号１
    this.aftCtrperTelNo1.setValue(turnonWorkInfo.afCtrperTel1);
    // 変更後　契約者電話番号区分１
    this.selectedAftCtrperTelNoDiv1.value = turnonWorkInfo.afCtrperTeldivision1;
    this.selectedAftCtrperTelNoDiv1.viewValue = turnonWorkInfo.afCtrperTeldivision1Aname;
    // 変更後　契約者電話番号２
    this.aftCtrperTelNo2.setValue(turnonWorkInfo.afCtrperTel2);
    // 変更後　契約者電話番号区分２
    this.selectedAftCtrperTelNoDiv2.value = turnonWorkInfo.afCtrperTeldivision2;
    this.selectedAftCtrperTelNoDiv2.viewValue = turnonWorkInfo.afCtrperTeldivision2Aname;
    // 変更後　契約者電話番号３
    this.aftCtrperTelNo3.setValue(turnonWorkInfo.afCtrperTel3);
    // 変更後　契約者電話番号区分３
    this.selectedAftCtrperTelNoDiv3.value = turnonWorkInfo.afCtrperTeldivision3;
    this.selectedAftCtrperTelNoDiv3.viewValue = turnonWorkInfo.afCtrperTeldivision3Aname;
  }

  /**
   * 契約者情報を設定する（契約情報取得（ガス））
   * @memberof Sgkb122dComponent
   */
  setCtrperInfoFromSmza301a(gasCtrSearchResultDto: Szma301aResponseGasCtrSearchResultDto): void {

    // 契約者情報
    let ctrperMstInfo = gasCtrSearchResultDto.ctrperMstInfo;

    // 名義（漢字）
    this.name = ctrperMstInfo.visitName + this.keishou;
    // 名義（カナ）
    this.nameKana = ctrperMstInfo.visitKanaName + this.keishou;
    // 契約者電話番号１
    if (ctrperMstInfo.telNo1 != null) {
      this.befCtrperTelNo1 = ctrperMstInfo.telNo1 + "(" + ctrperMstInfo.telNoDiv1Aname + ")";
    }
    // 契約者電話番号２
    if (ctrperMstInfo.telNo2 != null) {
      this.befCtrperTelNo2 = ctrperMstInfo.telNo2 + "(" + ctrperMstInfo.telNoDiv2Aname + ")";
    }
    // 契約者電話番号３
    if (ctrperMstInfo.telNo3 != null) {
      this.befCtrperTelNo3 = ctrperMstInfo.telNo3 + "(" + ctrperMstInfo.telNoDiv3Aname + ")";
    }
  }

  /**
   * 使用者情報を設定する
   * @memberof Sgkb122dComponent
   */
  setUserInfo(commonAceptSearchResult: Sgkb575aResCommonAceptSearchResultDto): void {

    // 使用者情報
    let userInfo = commonAceptSearchResult.userInfo;
    // 開栓作業時情報
    let turnonWorkInfo: Sgkb575aResTurnonWorkInfo = {};
    if (commonAceptSearchResult.turnonWorkInfo != null) {
      turnonWorkInfo = commonAceptSearchResult.turnonWorkInfo;
    }
    // 変更前の「使用需要者区分」を非表示項目に保持する
    this.befUsingjyuyoshaDiv = commonAceptSearchResult.userInfo.usingJuyoshaDiv;
    // 使用需要者区分（判定用）
    let usingjyuyoshaDiv: String = null;
    if (turnonWorkInfo.afUsingjyuyoshaDiv != null) {
      usingjyuyoshaDiv = turnonWorkInfo.afUsingjyuyoshaDiv;
    } else {
      usingjyuyoshaDiv = this.befUsingjyuyoshaDiv;
    }

    // 契約者と同じ
    if (usingjyuyoshaDiv == SgkbConstains.CODE.JYUYOSHA_DIV.SAMEAS_CONTRACTOR) {
      this.isSameKeiyaku.setValue(true);
    }
    if (this.befUsingjyuyoshaDiv == SgkbConstains.CODE.JYUYOSHA_DIV.DIRECT) {
      // 使用者名義（漢字）
      this.userName = userInfo.userName;
      // 使用者名義（カナ）
      this.userNameKana = userInfo.userKanaName;
      // 使用者電話番号１
      if (userInfo.userTelNo1 != null) {
        this.befUserTelNo1 = userInfo.userTelNo1 + "(" + userInfo.userTeldv1Aname + ")";
      }
      // 使用者電話番号２
      if (userInfo.userTelNo2 != null) {
        this.befUserTelNo2 = userInfo.userTelNo2 + "(" + userInfo.userTeldv2Aname + ")";
      }
      // 使用者電話番号３
      if (userInfo.userTelNo3 != null) {
        this.befUserTelNo3 = userInfo.userTelNo3 + "(" + userInfo.userTeldv3Aname + ")";
      }
    }
    // 変更後　使用者名義（漢字）
    this.aftUserName.setValue(turnonWorkInfo.afUsrvstKnjnm);
    // 変更後　使用者名義（カナ）
    this.aftUserNameKana.setValue(turnonWorkInfo.afUsrvstKananame);
    // 変更後　使用者電話番号１
    this.aftUserTelNo1.setValue(turnonWorkInfo.afUsrvstTel1);
    // 変更後　使用者電話番号区分１
    this.selectedAftUserTelNoDiv1.value = turnonWorkInfo.afUsrvstTeldivision1;
    this.selectedAftUserTelNoDiv1.viewValue = turnonWorkInfo.afUsrvstTeldivision1Aname;
    // 変更後　使用者電話番号２
    this.aftUserTelNo2.setValue(turnonWorkInfo.afUsrvstTel2);
    // 変更後　使用者電話番号区分２
    this.selectedAftUserTelNoDiv2.value = turnonWorkInfo.afUsrvstTeldivision2;
    this.selectedAftUserTelNoDiv2.viewValue = turnonWorkInfo.afUsrvstTeldivision2Aname;
    // 変更後　使用者電話番号３
    this.aftUserTelNo3.setValue(turnonWorkInfo.afUsrvstTel3);
    // 変更後　使用者電話番号区分３
    this.selectedAftUserTelNoDiv3.value = turnonWorkInfo.afUsrvstTeldivision3;
    this.selectedAftUserTelNoDiv3.viewValue = turnonWorkInfo.afUsrvstTeldivision3Aname;
  }

  /**
   * 画面項目：電話番号区分リストを設定する
   * @memberof Sgkb122dComponent
   */
  setTelNoDivList(): void {
    let codeConversionMstDtoList = this.codeConversionMstMap.get(this.displayItemIdC000010);
    let telNoDivList: SelectBox[] = [];
    // 「コードリスト」の件数分、電話番号区分リストを設定
    for (const codeConversionMstDto of codeConversionMstDtoList) {
      let telNoDiv: SelectBox =
      {
        value: codeConversionMstDto.userCode,
        viewValue: codeConversionMstDto.hyojiCont
      };
      telNoDivList.push(telNoDiv);
    }
    this.aftCtrperTelNoDivList1 = telNoDivList;
    this.aftCtrperTelNoDivList2 = telNoDivList;
    this.aftCtrperTelNoDivList3 = telNoDivList;
    this.aftUserTelNoDivList1 = telNoDivList;
    this.aftUserTelNoDivList2 = telNoDivList;
    this.aftUserTelNoDivList3 = telNoDivList;
  }

  /**
   * 画面項目：付帯契約リストを設定する
   * @memberof Sgkb122dComponent
   */
  setFtiContractList(displayableFtiGoodsList: Sgkb575aResFtiGoods[], prdCode): void {
    let ftiContractList: Futai[] = [];
    // 「表示可能付帯商品契約リスト」の件数分、付帯契約リストを設定
    for (const displayableFtiGoods of displayableFtiGoodsList) {
      let fti: Futai =
      {
        prdCode: prdCode,
        goodsCode: displayableFtiGoods.goodsCode,
        goodsDispAname: displayableFtiGoods.prdGoodsAname
      };
      ftiContractList.push(fti);
    }
    // 付帯契約リストが設定されている場合
    if (ftiContractList.length > 0) {
      // 画面項目：付帯契約リストに設定
      this.ftiContractList = ftiContractList;
      // 画面項目：付帯契約（選択値）を設定
      this.selectedFtiContract.prdCode = prdCode;
      this.selectedFtiContract.goodsCode = displayableFtiGoodsList[0].goodsCode;
      this.selectedFtiContract.goodsDispAname = displayableFtiGoodsList[0].prdGoodsAname;
    }
  }

  /**
   * 画面項目：開栓作業担当社員情報を設定する
   * @param commonAceptSearchResult 
   */
  setTurnonWorkchargeStaf(commonAceptSearchResult: Sgkb575aResCommonAceptSearchResultDto): void {

    // 開栓作業担当社員番号が設定されている場合
    if (commonAceptSearchResult.gasConInfo.turnonWorkchargeStafno != null) {
      /** 画面項目：開栓作業担当社員番号 */
      this.turnonWorkchargeStafno = commonAceptSearchResult.gasConInfo.turnonWorkchargeStafno;

      /** 画面項目：開栓作業担当社員名 */
      this.callSgkz011a(this.turnonWorkchargeStafno);
    } else {
      this.isVisibleTurnOnStaf = false;
    }
  }

  /**
   * 非表示項目：付帯商品契約情報（共通受付照会APIレスポンス情報）を設定する
   * @memberof Sgkb122dComponent
   */
  setFtiGoodsInfo(notDisplayableFtiGoodsList: Sgkb575aResFtiGoods[]): void {
    let ftiGoodsList: Array<Sgkb121aReqFtiGoodsDto> = [];
    // 「表示不可付帯商品契約リスト」の件数分、非表示項目:付帯商品契約情報（共通受付照会APIレスポンス情報） を設定
    for (const notDisplayableFtiGoods of notDisplayableFtiGoodsList) {
      let ftiGoods: Sgkb121aReqFtiGoodsDto = {
        "goodsCode": notDisplayableFtiGoods.goodsCode,
        "futaicontractdocumntNo": notDisplayableFtiGoods.futaicontractdocumntNo,
        "applyStartDate": notDisplayableFtiGoods.applyStartDate,
        "expireScheduleyearmonth": notDisplayableFtiGoods.expireScheduleyearmonth,
        "duration": notDisplayableFtiGoods.duration,
      };
      // 契約割引リストが設定されている場合
      if (notDisplayableFtiGoods.ctrDiscntsList != null) {
        ftiGoods.ctrDiscntsList = [];
        // 契約割引リストの件数分、非表示項目:付帯商品契約情報（共通受付照会APIレスポンス情報）の契約割引リストを設定
        for (const hiddenFtiGoodsCtrDiscnts of notDisplayableFtiGoods.ctrDiscntsList) {
          let ctrDiscnts: Sgkb121aReqCtrDiscntsDto = {
            "chargeCode": hiddenFtiGoodsCtrDiscnts.chargeCode,
            "discntSiteiDiv1": hiddenFtiGoodsCtrDiscnts.discntSiteiDiv1,
            "discntSiteiDiv2": hiddenFtiGoodsCtrDiscnts.discntSiteiDiv2,
            "discntSiteiDiv3": hiddenFtiGoodsCtrDiscnts.discntSiteiDiv3,
            "discntSiteiDiv4": hiddenFtiGoodsCtrDiscnts.discntSiteiDiv4,
            "discntSiteiDiv5": hiddenFtiGoodsCtrDiscnts.discntSiteiDiv5,
            "discntAname": hiddenFtiGoodsCtrDiscnts.discntAname,
            "discntRyaku": hiddenFtiGoodsCtrDiscnts.discntRyaku,
            "discntRangeStart": hiddenFtiGoodsCtrDiscnts.discntRangeStart,
            "discntRangeEnd": hiddenFtiGoodsCtrDiscnts.discntRangeEnd,
            "discntType": hiddenFtiGoodsCtrDiscnts.discntType,
            "discntTargetMin": hiddenFtiGoodsCtrDiscnts.discntTargetMin,
            "discntMaxValue": hiddenFtiGoodsCtrDiscnts.discntMaxValue,
            "discntRate": hiddenFtiGoodsCtrDiscnts.discntRate,
          }
          ftiGoods.ctrDiscntsList.push(ctrDiscnts);
        }
      }
      ftiGoodsList.push(ftiGoods);
    }
    this.ftiGoodsInfoForCmnAceptSearchRes.ftiGoodsList = ftiGoodsList;
  };

  /**
   * 非表示項目：契約単価情報に契約単価リストを設定する
   * @memberof Sgkb122dComponent
   */
  setCtrTankaMstList(resCtrTankaMstList: Array<Sgkb575aResCtrTankaDto>): void {
    let ctrTankaMstList: Array<Sgkb121aReqCtrTankaDto> = [];
    // レスポンスの契約単価リストの件数分、非表示項目:契約単価情報の契約単価リストに設定
    for (const resCtrTankaMst of resCtrTankaMstList) {
      let ctrTankaMst: Sgkb121aReqCtrTankaDto = {
        "goodsCode": resCtrTankaMst.goodsCode,
        "chargeCode": resCtrTankaMst.chargeCode,
        "tankaSiteiDiv1": resCtrTankaMst.tankaSiteiDiv1,
        "tankaSiteiDiv2": resCtrTankaMst.tankaSiteiDiv2,
        "tankaSiteiDiv3": resCtrTankaMst.tankaSiteiDiv3,
        "tankaSiteiDiv4": resCtrTankaMst.tankaSiteiDiv4,
        "tankaSiteiDiv5": resCtrTankaMst.tankaSiteiDiv5,
        "ctrtnkAname": resCtrTankaMst.ctrtnkAname,
        "ctrtnkRyaku": resCtrTankaMst.ctrtnkRyaku,
        "tankaRangeStart": resCtrTankaMst.tankaRangeStart,
        "tankaRangeEnd": resCtrTankaMst.tankaRangeEnd,
        "tanka": resCtrTankaMst.tanka,
        "choseiTankaCode": resCtrTankaMst.choseiTankaCode,
      };
      ctrTankaMstList.push(ctrTankaMst);
    }
    this.ctrTankaInfo = {
      ctrTankaMstList: ctrTankaMstList
    };
  }

  /**
   * ガス設備関連情報取得APIを呼び出して業種を取得し、画面項目や非表示項目などを設定する
   * @memberof Sgkb122dComponent
   */
  setItemsFromGasEquipmentInfo(suppntSpno: string): void {
    // ガス設備関連情報取得リクエスト設定
    const sgkb502aRequest: Sgkb502aRequest = {
      gasEquipmentinformation: {
        // 供給地点特定番号
        suppntSpno: suppntSpno,
        // 供給地点情報照会フラグ
        suppntInfoRefflg: false,
      }
    };
    // ガス設備関連情報取得レスポンス取得
    this.usedSgkb122dSgkb502aService.searchContractor(sgkb502aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        // 非表示項目：業種に設定
        this.hiddenGyoshu = response.gasEquipmentinformation.gyoshuCode;
        // 画面項目：業種の設定
        this.setGyoshuForCodeConversion(this.hiddenGyoshu);
        // エネルギー種別コードが「都市ガス」かつ、「ガス業種小分類」が100番台の業種の場合
        if (this.energyClscode === SgkbConstains.CODE.ENEGY_CLS_CD.CITY_GAS && this.hiddenGyoshu.substring(0, 1) === "1") {
          // お得なガス料金プランURL設定
          this.setBargainGasPricePlans(this.companycode);
        } else {
          // お得なガス料金プランはこちらを非表示にする
          this.isVisibleBargainGasPricePlans = false;
        }
        // 重要事項説明 共通事項URL設定
        this.setImportantItemUrl(this.hiddenGyoshu);
        // 非表示項目：付帯契約リスト(全量)を初期化
        this.ftiContractListForAll = [];
        // 非表示項目：付帯商品情報を初期化
        this.futaiGoodsInfo = {
          futaiGoodsList: []
        };
        // 料金プランリスト・付帯契約リスト設定
        this.setPricePlanListAndFtiContractList();
        // 会社コードが西部ガスかつ業種が公団かつ料金プランが床暖房契約（ホットメリット）の場合
        if (Sgkb122dComponent.SAIBU_GAS === this.companycode &&
          Sgkb122dComponent.KOUDAN_LIST.includes(this.hiddenGyoshu) &&
          Sgkb122dComponent.FLOOR_HEATING_CTR === this.prdCodeAtTimeAcept) {
          // 公団床暖房の申込書受領を表示する
          this.isVisiblePublicCorporationFloorHeatingSrndocReceipt = true;
          this.publicCorporationFloorHeatingSrndocReceipt.setValidators([Validators.requiredTrue]);
          this.publicCorporationFloorHeatingSrndocReceipt.updateValueAndValidity();
        }
      });
  }

  /**
   * 非表示項目：業種をコード変換マスタで名称に変換し、画面項目：業種に設定する
   * @memberof Sgkb122dComponent
   */
  setGyoshuForCodeConversion(hiddenGyoshu: string): void {
    // コード変換マスタマップからガス業種小分類に紐づくコード変換マスタDtoリストを取得
    let codeConversionMstDtoList = this.codeConversionMstMap.get(this.displayItemIdS000690);
    // コード変換マスタDtoリストから事前に取得した業種に一致するコード変換マスタDtoを取得
    let codeConversionDto =
      codeConversionMstDtoList.find((codeConversion) => codeConversion.userCode === hiddenGyoshu);
    // コード変換マスタDtoから表示内容（＝業種の名称）を取得し、画面項目：業種に設定
    this.gyoshu = `${codeConversionDto.userCode}(${codeConversionDto.hyojiCont})`;
  }

  /**
   * お得なガス料金プランURL設定
   * @memberof Sgkb122dComponent
  */
  setBargainGasPricePlans(companycode: string): void {
    // コード値変換マスタマップからお得なガス料金プランURLキーに紐づくコード値変換マスタDtoリストを取得
    this.codeValueConversionMstDtoList = this.codeValueConversionMstMap.get(this.discrmClsCodeSgkb011);
    // コード値変換マスタDtoリストからガス種別「都市ガス」と事前に取得した会社コードに一致するコード値変換マスタDtoを取得
    let codeValueDto =
      this.codeValueConversionMstDtoList.find((codeValue) =>
        codeValue.cnversOriginCode1 === companycode && codeValue.cnversOriginCode2 === "01");
    // コード値変換マスタDtoが取得できている場合
    if (codeValueDto != null) {
      // コード値変換マスタDtoから変換後１テキスト（＝お得なガス料金プランURL）を取得
      this.bargainGasPricePlans = codeValueDto.cnversAfterText1;
    } else {
      // お得なガス料金プランはこちらを非表示にする
      this.isVisibleBargainGasPricePlans = false;
    }
  }

  /**
   *  重要事項説明 共通事項URL設定
   * @memberof Sgkb122dComponent
   */
  setImportantItemUrl(hiddenGyoshu: string): void {
    // コード値変換マスタマップから共通重要事項URLキーに紐づくコード値変換マスタDtoリストを取得
    this.codeValueConversionMstDtoList = this.codeValueConversionMstMap.get(this.discrmClsCodeSgkb012);
    // コード値変換マスタDtoリストから事前に取得した会社コード、業種の１桁目に一致するコード値変換マスタDtoを取得
    let codeValueDto =
      this.codeValueConversionMstDtoList.find((codeValue) =>
        codeValue.cnversOriginCode1 === this.companycode && codeValue.cnversOriginCode2 === hiddenGyoshu.substring(0, 1));
    // コード値変換マスタDtoから変換後１テキスト（＝重要事項説明 共通事項URL）を取得
    this.importantItemUrl = codeValueDto.cnversAfterText1;
  }

  /**
   *  料金プランリスト・付帯契約リスト設定
   * @memberof Sgkb122dComponent
   */
  setPricePlanListAndFtiContractList(): void {
    // お客さま照会リクエスト設定
    const szoa104aRequest: Szoa104aRequest = {
      visitSearchInfo: {
        // 内部お客さま番号リスト
        visitNoList: [this.visitNo],
      }
    };
    // お客さま照会レスポンス取得
    this.usedSgkb122dSzoa104aService.searchContractor(szoa104aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(szoa104aResponse => {

        let VisitSearchResultDetailDto = szoa104aResponse.visitSearchResultDetailList[0];
        // 画面項目：名前が設定されていない場合、レスポンスの内容を設定する。
        if (this.name == null) {
          this.name = VisitSearchResultDetailDto.visitName + this.keishou;
          this.nameKana = VisitSearchResultDetailDto.visitKanaName + this.keishou;
          if (VisitSearchResultDetailDto.telNo1 != null) {
            this.befCtrperTelNo1 = VisitSearchResultDetailDto.telNo1 + "(" + VisitSearchResultDetailDto.telNoDiv1Aname + ")";
          }
          if (VisitSearchResultDetailDto.telNo2 != null) {
            this.befCtrperTelNo2 = VisitSearchResultDetailDto.telNo2 + "(" + VisitSearchResultDetailDto.telNoDiv2Aname + ")";
          }
          if (VisitSearchResultDetailDto.telNo3 != null) {
            this.befCtrperTelNo3 = VisitSearchResultDetailDto.telNo3 + "(" + VisitSearchResultDetailDto.telNoDiv3Aname + ")";
          }
        }
        // レスポンス共通を取得
        let responseCommon = szoa104aResponse.responseCommon;
        // レスポンスカスタマイズエリアを取得
        let responseCustomize = <Szoa104aCustomResponse>responseCommon.responseCustomize
        // レスポンスの内容を非表示項目：取次契約詳細コードに設定
        this.agencyontractSyosaicode = responseCustomize.companygroupNotificationmethodList[0].agencycontractSyosaicode;
        // プロダクト一覧取得リクエストに設定する中継店内部お客さま番号の設定
        let rlyisdVisitNoForSet: string;
        // 非表示項目：販売形態コードが「直販」の場合
        if (this.salfrmCode === SgkbConstains.CODE.SALES_MODEL_DIV.DIRECTSALE) {
          rlyisdVisitNoForSet = "999999999999999";
        } else {
          rlyisdVisitNoForSet = this.visitNo;
        }
        // プロダクト一覧取得リクエストに設定する検索用プロダクトコード、非表示項目：プロダクト種別区分の設定
        let prdCodeForSearch: string = null;
        let retailkaisenRslhyojiTargetflagForSearch: string = null;
        // 非表示項目：自用フラグが「自用」の場合
        if (this.selfuseFlg === SgkbConstains.CODE.JIYOU_FLG.JIYOU) {
          // 非表示項目：プロダクト種別区分に「自用」を設定
          this.prdClsfyDivList = [SgkbConstains.CODE.PRDCT_CLY_DIV_CD.JIYOU];
        } else if (this.agencyontractSyosaicode === SgkbConstains.CODE.TORITSUGI_CNTRCT_DETAIL_CD.OROSHI_SUPPLY) {
          // 非表示項目：取次契約詳細コードが「卸供給」の場合
          // 非表示項目：プロダクト種別区分に「卸供給」を設定
          this.prdClsfyDivList = [SgkbConstains.CODE.PRDCT_CLY_DIV_CD.OROSHISUPPLY];
        } else if (this.registrationstatus !== null ||
          this.opentapresultRegistrationflag === SgkbConstains.CODE.OPEN_RESULT_REGISTED_FLG.REGISTED) {
          // 契約登録受付画面から登録した場合、または被総合開栓の2件目以降の場合
          // 検索用プロダクトコードに受付時プロダクトコードを設定し、
          // 非表示項目：プロダクト種別区分に「null」を設定
          prdCodeForSearch = this.prdCodeAtTimeAcept;
          this.prdClsfyDivList = [null];
          // 入居前点検、空き家修繕工事の場合
        } else if (this.turnonClscode === SgkbConstains.CODE.TURN_ON_CLS_CODE.PRECHECK ||
          this.turnonClscode === SgkbConstains.CODE.TURN_ON_CLS_CODE.VACANTREPAIR) {
          // 検索用プロダクトコードに受付時プロダクトコードを設定し、
          // 非表示項目：プロダクト種別区分に「99」を設定
          prdCodeForSearch = this.prdCodeAtTimeAcept;
          this.prdClsfyDivList = [SgkbConstains.CODE.PRDCT_CLY_DIV_CD.PRECHECK_VACANTREPAIR];
        } else {
          // 上記以外の場合
          // 非表示項目：プロダクト種別区分に「null」を設定
          this.prdClsfyDivList = [null];
          // 小売開栓結果表示対象フラグに「対象」を設定
          retailkaisenRslhyojiTargetflagForSearch = SgkbConstains.CODE.RETAILKAISEN_RSLHYOJI_TARGETFLAG.TARGET;
        }
        // 非表示項目：プロダクト種別区分の件数分、プロダクト一覧取得APIを呼び出し、結果を取得
        for (const prdClsfyDiv of this.prdClsfyDivList) {
          //プロダクト一覧取得リクエスト設定
          const szoa109aRequest: Szoa109aRequest = {
            prdSearchInfo: {
              // 中継店内部お客さま番号
              rlyisdVisitNo: rlyisdVisitNoForSet,
              // サービス種別コード
              srvClsfyCode: SgkbConstains.CODE.SERVICE_CLY_CD.GAS,
              // プロダクト種別区分
              prdClsfyDiv: prdClsfyDiv,
              // プロダクトコード
              prdCode: prdCodeForSearch,
              // カスタマイズ検索条件エリア
              additionalCondition: {
                // 会社コード
                "companycode": this.companycode,
                // エネルギー種別コード
                "energyClscode": this.energyClscode,
                // 小売開栓結果表示対象フラグ
                "retailkaisenRslhyojiTargetflag": retailkaisenRslhyojiTargetflagForSearch
              }
            }
          };
          // プロダクト一覧取得レスポンス取得
          this.usedSgkb122dSzoa109aService.searchContractor(szoa109aRequest)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(szoa109aResponse => {
              // 非表示項目：自用フラグが「自用」の場合
              if (this.selfuseFlg === SgkbConstains.CODE.JIYOU_FLG.JIYOU) {
                // 画面項目：料金プラン（選択値）の初期値に取得した料金プランの1件目を設定
                this.selectedPricePlan.value = szoa109aResponse.prdSearchResultList[0].prd.prdCode;
                this.selectedPricePlan.viewValue = szoa109aResponse.prdSearchResultList[0].prd.prdAname;
                // 取得した料金プランの1件目を画面項目：料金プランリストに設定する
                let pricePlan: SelectBox =
                {
                  value: szoa109aResponse.prdSearchResultList[0].prd.prdCode,
                  viewValue: szoa109aResponse.prdSearchResultList[0].prd.prdAname
                };
                this.pricePlanList.push(pricePlan);

              } else if (this.registrationstatus !== null ||
                this.opentapresultRegistrationflag === SgkbConstains.CODE.OPEN_RESULT_REGISTED_FLG.REGISTED ||
                this.turnonClscode === SgkbConstains.CODE.TURN_ON_CLS_CODE.PRECHECK ||
                this.turnonClscode === SgkbConstains.CODE.TURN_ON_CLS_CODE.VACANTREPAIR) {
                // 契約登録受付画面から登録した場合、または被総合開栓の2件目以降の場合
                // または入居前点検、空き家修繕工事の場合
                // 画面項目：料金プラン（選択値）の初期値に受付時プロダクトコード、名称を設定
                this.selectedPricePlan.value = this.prdCodeAtTimeAcept;
                this.selectedPricePlan.viewValue = this.prdCodeAnameAtTimeAcept;
                // 受付時の料金プランを画面項目：料金プランリストに設定する
                let pricePlan: SelectBox =
                {
                  value: this.prdCodeAtTimeAcept,
                  viewValue: this.prdCodeAnameAtTimeAcept
                };
                this.pricePlanList.push(pricePlan);
                // プロダクト種別区分コードマップにキー：プロダクトコード、バリュー：プロダクト種別区分コードを設定
                this.prdClsfyDivCodeMap.set(this.prdCodeAtTimeAcept, szoa109aResponse.prdSearchResultList[0].prd.prdClsfyDiv);

              } else {
                // 上記以外の場合

                if (this.turnonWorkchargeStafno !== null) {
                  // 開栓作業担当社員番号が設定されている場合

                  // 画面項目：料金プラン（選択値）の初期値に受付時プロダクトコード、名称を設定
                  this.selectedPricePlan.value = this.prdCodeAtTimeAcept;
                  this.selectedPricePlan.viewValue = this.prdCodeAnameAtTimeAcept;
                }

                // プロダクト一覧取得レスポンスのプロダクト検索結果リストの件数分、画面項目：料金プランリストを設定
                for (const prdSearchResult of szoa109aResponse.prdSearchResultList) {
                  let pricePlan: SelectBox =
                  {
                    value: prdSearchResult.prd.prdCode,
                    viewValue: prdSearchResult.prd.prdAname
                  };
                  this.pricePlanList.push(pricePlan);
                  // プロダクト種別区分コードマップにキー：プロダクトコード、バリュー：プロダクト種別区分コードを設定
                  this.prdClsfyDivCodeMap.set(prdSearchResult.prd.prdCode, prdSearchResult.prd.prdClsfyDiv);
                }
              }

              // ループカウンタ
              let loopCnt = 0;
              // プロダクト一覧取得レスポンスのプロダクト検索結果リストの件数分、付帯商品一覧取得APIを呼び出し、結果を取得
              for (const prdSearchResult of szoa109aResponse.prdSearchResultList) {
                // ループカウンタを加算
                loopCnt++;
                // 付帯商品一覧取得リクエスト設定
                const szoa110aRequest: Szoa110aRequest = {
                  ftiGoodsSearchInfo: {
                    // プロダクトコード
                    prdCode: prdSearchResult.prd.prdCode,
                  }
                };
                // 付帯商品一覧取得レスポンス取得
                this.usedSgkb122dSzoa110aService.searchContractor(szoa110aRequest)
                  .pipe(takeUntil(this.onDestroy$))
                  .subscribe(szoa110aResponse => {
                    // 付帯商品検索結果リストが設定されている場合
                    if (szoa110aResponse.ftiGoodsSearchResultList != null) {
                      // 
                      if (this.futaiGoodsInfo === undefined) {
                        this.futaiGoodsInfo = {
                          futaiGoodsList: []
                        };
                      }
                      let ftiGoodsList: Array<FutaiGoods> = [];
                      // 付帯商品検索結果リストの件数分、付帯商品リストに設定
                      for (const ftiGoodsSearchResult of szoa110aResponse.ftiGoodsSearchResultList) {
                        let ftiGoods: FutaiGoods =
                        {
                          prdCode: ftiGoodsSearchResult.ftiGoodsPrm.prdCode,
                          goodsCode: ftiGoodsSearchResult.ftiGoodsPrm.goodsCode,
                          prdGoodsAname: ftiGoodsSearchResult.ftiGoodsPrm.prdGoodsAname,
                          ctrDiscntsList: []
                        };
                        // 契約割引リストが設定されている場合
                        if (ftiGoodsSearchResult.ftiGoodsPrm.ctrDiscntPrmList != null) {
                          // 契約割引リストの件数分、非表示項目：付帯商品リストの付帯商品に契約割引リストを設定
                          for (const ctrDiscntPrm of ftiGoodsSearchResult.ftiGoodsPrm.ctrDiscntPrmList) {
                            let ctrDiscnts: CtrDiscnts =
                            {
                              chargeCode: ctrDiscntPrm.chargeCode,
                              discntSiteiDiv1: ctrDiscntPrm.discntSiteiDiv1,
                              discntSiteiDiv2: ctrDiscntPrm.discntSiteiDiv2,
                              discntSiteiDiv3: ctrDiscntPrm.discntSiteiDiv3,
                              discntSiteiDiv4: ctrDiscntPrm.discntSiteiDiv4,
                              discntSiteiDiv5: ctrDiscntPrm.discntSiteiDiv5,
                              discntAname: ctrDiscntPrm.discntAname,
                              discntRyaku: ctrDiscntPrm.discntRyaku,
                              discntRangeStart: ctrDiscntPrm.discntRangeStart,
                              discntRangeEnd: ctrDiscntPrm.discntRangeEnd,
                              discntType: ctrDiscntPrm.discntType,
                              discntTargetMin: ctrDiscntPrm.discntTargetMin,
                              discntMaxValue: ctrDiscntPrm.discntMaxValue,
                              discntRate: ctrDiscntPrm.discntRate
                            }
                            ftiGoods.ctrDiscntsList.push(ctrDiscnts);
                          }
                        }
                        ftiGoodsList.push(ftiGoods);
                      }
                      // 画面項目：付帯契約リストの設定
                      // 「表示可能付帯商品コードリスト」の商品コードと一致する「付帯商品リスト．付帯商品」を「表示可能付帯商品契約リスト」として取得
                      let displayableFtiGoodsList: FutaiGoods[] =
                        ftiGoodsList.filter(ftiGoods => this.displayableFtiGoodsCodeList.includes(ftiGoods.goodsCode));
                      let ftiContractList: Futai[] = [];
                      // 表示可能付帯商品契約リストの件数分、非表示項目：付帯契約リスト(全量) に設定
                      for (const ftiContract of displayableFtiGoodsList) {
                        let fti: Futai =
                        {
                          prdCode: ftiContract.prdCode,
                          goodsCode: ftiContract.goodsCode,
                          goodsDispAname: ftiContract.prdGoodsAname
                        };
                        ftiContractList.push(fti);
                      }
                      // 非表示項目：付帯契約リスト(全量) に設定
                      this.ftiContractListForAll.push(...ftiContractList);
                      // 非表示項目：付帯商品情報に付帯商品リストを追加
                      this.futaiGoodsInfo.futaiGoodsList.push(...ftiGoodsList);

                      // プロダクト検索結果リストの件数分、処理を繰り返した場合
                      if (loopCnt === szoa109aResponse.prdSearchResultList.length) {
                        //　画面項目：付帯契約リストの初期設定
                        this.onPricePlanChange(this.selectedPricePlan.value);
                      }
                    }
                  });
              }
            });
        }
      });
  };

  /**
   * 支払方法設定
   * @memberof Sgkb122dComponent
   */
  setPayMethod(aceptNo: string): void {
    // 支払方法変更_受付中返却リクエスト設定
    const sgkd036aRequest: Sgkd036aRequest = {
      requestDto: {
        ctrstrAceptInfo: {
          // 受付番号
          aceptNo: aceptNo
        }
      }
    };
    // 支払方法変更_受付中返却レスポンス取得
    this.usedSgkb122dSgkd036aService.searchContractor(sgkd036aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(sgkd036aResponse => {
        // レスポンスが設定されている場合
        if (sgkd036aResponse.responseDto != null) {
          // レスポンスの内容を画面項目：支払方法に設定
          this.payMethod = sgkd036aResponse.responseDto.paymtdChginfo.paymtdAname;
        }

        //この時点で画面項目：支払方法が設定されていない場合
        if (this.payMethod === null) {
          // 非表示項目：請求お客さま番号の設定がある場合
          if (this.recptFixNo != null) {
            // 請求先・請求情報取得API呼び出し
            this.callSzme004a();
          } else {
            // 「振込票」を設定
            this.payMethod = "払込票";
          }
        }
      });
  };

  /**
  * 請求先・請求情報取得API呼び出し
  * @memberof Sgkb122dComponent
  */
  callSzme004a(): void {
    // 請求先・請求情報取得リクエスト設定
    const szme004aRequest: Szme004aRequest = {
      // 請求お客さま番号
      recptFixNo: this.recptFixNo,
    };
    // 請求先・請求情報取得レスポンス取得
    this.usedSgkb122dSzme004aService.searchContractor(szme004aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(szme004aResponse => {
        // レスポンスが設定されている場合
        if (szme004aResponse.clmtoClaimInfGetInfDto != null) {
          // レスポンスの内容を画面項目：支払方法に設定
          this.payMethod = szme004aResponse.clmtoClaimInfGetInfDto.claimInf01Dto.payMethodDivAname;
        }
        //この時点で画面項目：支払方法が設定されていない場合
        if (this.payMethod === null) {
          this.payMethod = "払込票";
        }
      });
  }

  /**
   * ユーザー情報取得
   * @memberof Sgkb122dComponent
   */
  callSgkz011a(userId: string): void {
    // ユーザー情報取得リクエスト設定
    const sgkz011aRequest: Sgkz011aRequest = {
      userId: userId
    };

    // ユーザー情報取得レスポンス取得
    this.usedSgkb122dSgkz011aService.searchContractor(sgkz011aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(sgkz011aResponse => {
        // レスポンスのユーザー漢字氏名が取得できた場合、開栓作業担当社員名を設定
        if (sgkz011aResponse != null && sgkz011aResponse.usrKanjiname != null) {
          this.turnonWorkchargeStafName = sgkz011aResponse.usrKanjiname;
        }
      });
  };

  /** 
   * 変更後契約者情報フォーカスアウト時イベント（種類：テキスト用）
   * @memberof Sgkb122dComponent
   */
  changeAfCtrperInfoForInput(event: Event): void {
    this.changeAfCtrperInfo((event.target as HTMLInputElement).value);
  }

  /** 
  * 変更後契約者情報フォーカスアウト時イベント（種類：リスト用）
  * @memberof Sgkb122dComponent
  */
  changeAfCtrperInfoForSelect(event: MatSelectChange): void {
    this.changeAfCtrperInfo(event.value);
  }

  /** 
   * 変更後契約者情報フォーカスアウト時
   * @memberof Sgkb122dComponent
   */
  changeAfCtrperInfo(targrtVal: String): void {
    // 入力値が空以外の場合
    if (targrtVal && targrtVal != '') {
      // 「センター要確認」のチェックをONにする
      this.pricePlanNeedConfirm.setValue(true);
    }
  }

  /**
   * 登録ボタン押下時イベント
   * @memberof Sgkb122dComponent
   */
  onSubmit(): void {

    let result = true;
    // 業種と料金プランの整合性チェック
    if (!this.chkIntegrityGyoshuAndPlan()) {
      // チェック結果NGの場合
      if (this.vstinfMemo.value == null || this.vstinfMemo.value == "") {
        // 「作業者メモ」が入力されていない場合、エラーメッセージを出力
        let messageList: string[] = [this.warnMsgForchkIntegrityGyoshuAndPlan];
        this.errorHandlingForSubmit(messageList);
        this.isOutputError = true
        result = false;
      } else if (this.isOutputError == false) {
        // エラーメッセージを一度も出力していない場合、警告メッセージを出力
        result = window.confirm(this.warnMsgForchkIntegrityGyoshuAndPlan);
      }
    }

    if (result) {
      // 開栓作業時（＝画面間パラメータの業種が設定されている場合）
      if (this.displayParamGyoshu != null) {
        // 署名欄を画像ファイルに変換
        const canvas = document.getElementById('signatureCanvas') as HTMLCanvasElement;
        const image = canvas.toDataURL('image/jpeg');
        // BlobからFileを作成
        const blob = this.dataURLtoBlob(image);
        const uploadFile = new File([blob], '販売契約書.jpeg', { type: 'image/jpeg' });
        // アップロード機能レスポンス取得
        this.usedSgkb122dSzza006aService.upload(this.ulFileType00009, uploadFile).pipe(takeUntil(this.onDestroy$))
          .subscribe(response => {
            this.uploadInternalFileName = response.uploadInternalFileName;
            // 小売開栓結果登録API呼び出し
            this.callSgkb121a();
          });

      } else {
        // センター要確認後の変更（＝画面間パラメータの業種が設定されていない場合）
        // 小売開栓結果登録API呼び出し
        this.callSgkb121a();
      }
    }
  }

  /**
   * 業種と料金プランの整合性チェック
   * @memberof Sgkb122dComponent
   */
  chkIntegrityGyoshuAndPlan(): boolean {

    // 料金プランが非活性、かつ自用フラグがfalseの場合はチェックを実施しない
    if (this.planSelectFormGroup.get('pricePlanForDisplayControl')?.disabled
      && this.selfuseFlg != SgkbConstains.CODE.JIYOU_FLG.JIYOU) {
      return true;
    }

    // コード値変換マスタマップからプロダクト種別区分コードキーに紐づくコード値変換マスタDtoリストを取得
    this.codeValueConversionMstDtoList = this.codeValueConversionMstMap.get(this.discrmClsCodeSgkb014);
    // コード値変換マスタDtoリストから業種（大分類）に一致するコード値変換マスタDtoを取得
    let codeValueDtoList =
      this.codeValueConversionMstDtoList.filter((codeValue) => codeValue.cnversOriginCode1 == this.hiddenGyoshu.substring(0, 1));

    // 現在選択中の料金プランよりプロダクト種別区分を取得
    let prdClsfyDivCode = this.prdClsfyDivCodeMap.get(this.selectedPricePlan.value);
    for (const codeValueDto of codeValueDtoList) {
      // 選択可能なプロダクト種別区分に含まれている場合
      if (prdClsfyDivCode == codeValueDto.cnversAfterCode1) {
        return true;
      }
    }
    return false;
  }

  /**
   * Base64をBlobに変換
   * @memberof Sgkb122dComponent
   */
  dataURLtoBlob(dataurl: string): Blob {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || '';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  /**
   * 小売開栓結果登録API呼び出し
   * @memberof Sgkb122dComponent
   */
  callSgkb121a(): void {
    // 小売開栓結果登録リクエストに設定する要確認対象フラグを編集
    let needconfirmflagResponseFlgForSet: string;
    // 開栓作業時（＝画面間パラメータの業種が設定されている場合）
    if (this.displayParamGyoshu != null) {
      needconfirmflagResponseFlgForSet = "0";
    } else {
      // センター要確認後の変更（＝画面間パラメータの業種が設定されていない場合）
      needconfirmflagResponseFlgForSet = "1";
    }

    // 小売開栓結果登録リクエストに設定する「契約者情報」を編集
    let ctrperinfoChangeyesnoFlg: string = null;
    let afCtrperKnjnm: string = null;
    let afCtrperKananame: string = null;
    let afCtrperTel1: string = null;
    let afCtrperTeldivision1: string = null;
    let afCtrperTel2: string = null;
    let afCtrperTeldivision2: string = null;
    let afCtrperTel3: string = null;
    let afCtrperTeldivision3: string = null;
    if (this.ctrInfoChgUmu.value === false) {
      // 「変更なし」の場合
      ctrperinfoChangeyesnoFlg = SgkbConstains.CODE.CTRPERINFO_CHANGEYESNO_FLG.NOCHANGE
    } else {
      // 「変更あり」の場合
      ctrperinfoChangeyesnoFlg = SgkbConstains.CODE.CTRPERINFO_CHANGEYESNO_FLG.CHANGE
      afCtrperKnjnm = this.aftName.value;
      afCtrperKananame = this.aftNameKana.value;
      afCtrperTel1 = this.aftCtrperTelNo1.value;
      afCtrperTeldivision1 = this.selectedAftCtrperTelNoDiv1.value;
      afCtrperTel2 = this.aftCtrperTelNo2.value;
      afCtrperTeldivision2 = this.selectedAftCtrperTelNoDiv2.value;
      afCtrperTel3 = this.aftCtrperTelNo3.value;
      afCtrperTeldivision3 = this.selectedAftCtrperTelNoDiv3.value;
    }

    // 小売開栓結果登録リクエストに設定する「使用者情報」を編集
    let afUsingjyuyoshaDiv: string = null;
    let afUsrvstKnjnm: string = null;
    let afUsrvstKananame: string = null;
    let afUsrvstTel1: string = null;
    let afUsrvstTeldivision1: string = null;
    let afUsrvstTel2: string = null;
    let afUsrvstTeldivision2: string = null;
    let afUsrvstTel3: string = null;
    let afUsrvstTeldivision3: string = null;
    if (this.isSameKeiyaku.value === true) {
      // 「契約者と同じ」の場合
      afUsingjyuyoshaDiv = SgkbConstains.CODE.JYUYOSHA_DIV.SAMEAS_CONTRACTOR
    } else {
      // 「契約者と同じ」以外の場合
      afUsingjyuyoshaDiv = SgkbConstains.CODE.JYUYOSHA_DIV.DIRECT
      afUsrvstKnjnm = this.aftUserName.value
      afUsrvstKananame = this.aftUserNameKana.value
      afUsrvstTel1 = this.aftUserTelNo1.value
      afUsrvstTeldivision1 = this.selectedAftUserTelNoDiv1.value
      afUsrvstTel2 = this.aftUserTelNo2.value
      afUsrvstTeldivision2 = this.selectedAftUserTelNoDiv2.value
      afUsrvstTel3 = this.aftUserTelNo3.value
      afUsrvstTeldivision3 = this.selectedAftUserTelNoDiv3.value
    }
    // 変更前と使用需要者区分が変更されていない場合、リクエスト情報に設定しない
    if (this.befUsingjyuyoshaDiv == afUsingjyuyoshaDiv) {
      afUsingjyuyoshaDiv = null;
    }

    // 小売開栓結果登録リクエストに設定する手続き完了おしらせ直送可否フラグ、契約手続き完了通知紙希望フラグ、センター要確認フラグを編集
    let procedurecompletionNoticeDeliverypossibilityForSet: string = null;
    let ctrProcedurecompletionPaperhopeflagForSet: string = null;
    let priceplanNeedconfirmflagForSet: string = null;
    let publiccorporationfloorheatingSrndocReceiptflagForSet: string = null;
    // 画面項目：手続き完了おしらせ直送不可のチェックが入っている場合
    if (this.procedureCompletionNoticeDeliveryNotPossible.value === true) {
      // 手続き完了おしらせ直送可否フラグに「不可」を設定
      procedurecompletionNoticeDeliverypossibilityForSet = SgkbConstains.CODE.TETSUZUKI_COMP_NTC_DRT_KAHI_FLG.NONEED;
    } else if (this.procedureCompletionNoticeDeliveryNotPossible.value === false) {
      // 手続き完了おしらせ直送可否フラグに「可」を設定
      procedurecompletionNoticeDeliverypossibilityForSet = SgkbConstains.CODE.TETSUZUKI_COMP_NTC_DRT_KAHI_FLG.NEED;
    }
    // 画面項目：手続き完了おしらせ紙希望のチェックが入っている場合
    if (this.procedureCompletionNoticePaperHope.value === true) {
      // 契約手続き完了通知紙希望フラグに「希望あり」を設定
      ctrProcedurecompletionPaperhopeflagForSet = SgkbConstains.CODE.CNTRCT_TETSUZUKI_CMP_NTC_PAPER_FLG.PREF;
    } else if (this.procedureCompletionNoticePaperHope.value === false) {
      // 契約手続き完了通知紙希望フラグに「希望なし」を設定
      ctrProcedurecompletionPaperhopeflagForSet = SgkbConstains.CODE.CNTRCT_TETSUZUKI_CMP_NTC_PAPER_FLG.NOPREF;
    }
    // 画面項目：センター要確認のチェックが入っている場合
    if (this.pricePlanNeedConfirm.value === true) {
      // センター要確認フラグに「要」を設定
      priceplanNeedconfirmflagForSet = SgkbConstains.CODE.FEE_PLAN_CONFIRM_FLG.NEED;
    } else if (this.pricePlanNeedConfirm.value === false) {
      // センター要確認フラグに「不要」を設定
      priceplanNeedconfirmflagForSet = SgkbConstains.CODE.FEE_PLAN_CONFIRM_FLG.NONEED;
    }
    // 画面項目：公団床暖房の申込書受領のチェックが入っている場合
    if (this.publicCorporationFloorHeatingSrndocReceipt.value === true) {
      // 公団床暖の申込書受領フラグに「受領済」を設定
      publiccorporationfloorheatingSrndocReceiptflagForSet = SgkbConstains.CODE.KOUDAN_YUKADAN_APPFORM_RECEIVE_FLG.RECEIVED;
    } else if (this.publicCorporationFloorHeatingSrndocReceipt.value === false) {
      // 公団床暖の申込書受領フラグに「未受領」を設定
      publiccorporationfloorheatingSrndocReceiptflagForSet = SgkbConstains.CODE.KOUDAN_YUKADAN_APPFORM_RECEIVE_FLG.NOT_RECEIVE;
    }
    // リクエスト設定用付帯商品契約情報を初期化
    let ftiGoodsInfoForSet: Sgkb121aReqFtiGoodsInfoDto = null;
    // 非表示項目：付帯商品情報.付帯商品リストが設定されている場合
    if (this.futaiGoodsInfo.futaiGoodsList != null) {
      // 小売開栓結果登録リクエストに設定する付帯商品契約情報を編集
      // 画面項目：付帯契約（選択値）に紐づく付帯商品を非表示項目：付帯商品情報から取得し、選択済み付帯商品とする
      let selectedFtiGoods = this.futaiGoodsInfo.futaiGoodsList.find(futaiGoods => futaiGoods.goodsCode === this.selectedFtiContract.goodsCode);
      // 選択済み付帯商品が設定されている場合
      if (selectedFtiGoods !== undefined) {
        // 選択済み付帯商品を変換
        let convertFtiGoodsDto: Sgkb121aReqFtiGoodsDto = {
          "goodsCode": selectedFtiGoods.goodsCode,
          "futaicontractdocumntNo": null,
          "applyStartDate": null,
          "expireScheduleyearmonth": null,
          "duration": null,
          "ctrDiscntsList": null
        };
        // 選択済み付帯商品を非表示項目：付帯商品契約情報（共通受付照会APIレスポンス情報）に追加する
        this.ftiGoodsInfoForCmnAceptSearchRes.ftiGoodsList.push(convertFtiGoodsDto);
      }
      // 非表示項目：付帯商品情報から付帯商品コードリストを作成
      let futaiGoodsCodeList = this.futaiGoodsInfo.futaiGoodsList
        .filter(ftiGoods => ftiGoods.prdCode === this.selectedPricePlan.value).map(futaiGoods => futaiGoods.goodsCode);
      // 付帯商品コードリストが設定されている、かつ非表示項目：付帯商品契約情報（共通受付照会APIレスポンス情報）が設定されている場合
      if (futaiGoodsCodeList.length > 0 && this.ftiGoodsInfoForCmnAceptSearchRes.ftiGoodsList.length > 0) {
        // 非表示項目：付帯商品契約情報（共通受付照会APIレスポンス情報）のうち、付帯商品コードリストと一致する付帯商品契約を抽出し、設定対象付帯商品契約リストに設定
        let ftiGoodsListForTarget = this.ftiGoodsInfoForCmnAceptSearchRes.ftiGoodsList.filter(ftiGoods => futaiGoodsCodeList.includes(ftiGoods.goodsCode));
        // 設定対象付帯商品契約リストが空以外の場合
        if (ftiGoodsListForTarget.length > 0) {
          // 設定対象付帯商品契約リストの要素に含まれる契約割引リストにnullを設定し、リクエスト設定用付帯商品契約リストに設定
          let ftiGoodsListForSet = ftiGoodsListForTarget.map(ftiGoods => ({ ...ftiGoods, ctrDiscntsList: null }));
          // リクエスト設定用付帯商品契約情報.付帯商品契約リストを初期化
          ftiGoodsInfoForSet = {};
          // リクエスト設定用付帯商品契約リストをリクエスト設定用付帯商品契約情報に設定
          ftiGoodsInfoForSet.ftiGoodsList = ftiGoodsListForSet;
        }
      }
    }
    // リクエスト設定用プロダクト種別区分コードを編集
    let prdClsfyDivCodeForSet: string = null;
    // 非表示項目：自用フラグが「自用」の場合
    if (this.selfuseFlg === SgkbConstains.CODE.JIYOU_FLG.JIYOU) {
      // リクエスト設定用プロダクト種別区分コードに「自用」を設定
      prdClsfyDivCodeForSet = SgkbConstains.CODE.PRDCT_CLY_DIV_CD.JIYOU;
    } else if (this.agencyontractSyosaicode === SgkbConstains.CODE.TORITSUGI_CNTRCT_DETAIL_CD.OROSHI_SUPPLY) {
      // 非表示項目：取次契約詳細コードが「卸供給」の場合
      // リクエスト設定用プロダクト種別区分コードに「卸供給」を設定
      prdClsfyDivCodeForSet = SgkbConstains.CODE.PRDCT_CLY_DIV_CD.OROSHISUPPLY;
    } else {
      // 上記以外の場合
      prdClsfyDivCodeForSet = this.prdClsfyDivCodeMap.get(this.selectedPricePlan.value);
    }
    // 小売開栓結果登録リクエスト設定
    const sgkb121aRequest: Sgkb121aRequest = {
      aceptInfo: {
        aceptNo: this.aceptNo,
        aceptRrkno: this.aceptRrkno,
        updateSrno: this.updateSrno,
        ctrperinfoChangeyesnoFlg: ctrperinfoChangeyesnoFlg,
        afCtrperKnjnm: afCtrperKnjnm,
        afCtrperKananame: afCtrperKananame,
        afCtrperTel1: afCtrperTel1,
        afCtrperTeldivision1: afCtrperTeldivision1,
        afCtrperTel2: afCtrperTel2,
        afCtrperTeldivision2: afCtrperTeldivision2,
        afCtrperTel3: afCtrperTel3,
        afCtrperTeldivision3: afCtrperTeldivision3,
        afUsingjyuyoshaDiv: afUsingjyuyoshaDiv,
        afUsrvstKnjnm: afUsrvstKnjnm,
        afUsrvstKananame: afUsrvstKananame,
        afUsrvstTel1: afUsrvstTel1,
        afUsrvstTeldivision1: afUsrvstTeldivision1,
        afUsrvstTel2: afUsrvstTel2,
        afUsrvstTeldivision2: afUsrvstTeldivision2,
        afUsrvstTel3: afUsrvstTel3,
        afUsrvstTeldivision3: afUsrvstTeldivision3,
        publiccorporationfloorheatingSrndocReceiptflag: publiccorporationfloorheatingSrndocReceiptflagForSet,
        gasSuppntSpno: this.gasSuppntSpno,
        turnonWorkchargeStafno: this.usrId,
        procedurecompletionNoticeDeliverypossibility: procedurecompletionNoticeDeliverypossibilityForSet,
        ctrProcedurecompletionPaperhopeflag: ctrProcedurecompletionPaperhopeflagForSet,
        priceplanNeedconfirmflag: priceplanNeedconfirmflagForSet,
        vstinfMemo: this.tantoushaFormGroup.controls['vstinfMemo'].value,
        needconfirmflagResponseFlg: needconfirmflagResponseFlgForSet,
      },
      ctrCommonInfo: {
        prdCode: this.selectedPricePlan.value,
        prdClsfyDivCode: prdClsfyDivCodeForSet
      },
      ftiGoodsInfo: ftiGoodsInfoForSet,
      ctrTankaInfo: this.ctrTankaInfo,
      gasConInfo: {
        gasGyoshuSmallbunrui: this.hiddenGyoshu
      },
      signatureInfo: {
        signatureDiv: this.signatureDiv.value,
        signatureFilePath: this.uploadInternalFileName
      }
    };

    // 小売開栓結果登録レスポンス取得
    this.usedSgkb122dSgkb121aService.searchContractor(sgkb121aRequest)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        // レスポンス共通
        let responseCommon = response.responseCommon;
        // レスポンスの処理結果コードが「正常」の場合
        if (responseCommon.resultCode === SgkbConstains.RESULT_CD.NORMAL) {
          // 小売開栓結果登録画面を閉じる
          window.close();
        } else {
          // レスポンスの処理結果コードが「異常」の場合
          // レスポンスのラー内容リストの件数分、エラーメッセージを表示
          let messageList: string[] = [];
          for (const errors of responseCommon.errors) {
            messageList.push(errors.message);
          }
          this.errorHandlingForSubmit(messageList);
        }
      });
  };

  /**
   * 署名描画イベント
   * @param event 
   */
  ngAfterViewInit(): void { // コンポーネントのビュー初期化後に実行される処理
    const canvas = document.getElementById("signatureCanvas") as HTMLCanvasElement; // HTML内のcanvas要素を取得して型アサーション
    const ctx = canvas?.getContext("2d"); // 2D描画用のコンテキストを取得

    if (!ctx) { // コンテキストの取得に失敗した場合
      console.error("Canvasまたは2Dコンテキストの取得に失敗しました"); // エラーメッセージを出力
      return; // 処理を中断
    }

    let isDrawing = false; // タッチ操作中かどうかを管理するフラグ

    // タッチ位置を取得する関数
    const getTouchPos = (e: TouchEvent) => {
      const rect = canvas.getBoundingClientRect(); // canvasの位置情報を取得
      const touch = e.touches[0]; // 最初のタッチポイントを取得
      return {
        x: touch.clientX - rect.left, // canvas左端からのX座標
        y: touch.clientY - rect.top   // canvas上端からのY座標
      };
    };

    // タッチ開始時の処理
    canvas.addEventListener("touchstart", e => {
      e.preventDefault(); // デフォルトのスクロール動作を無効化
      const pos = getTouchPos(e); // タッチ位置を取得
      ctx.beginPath(); // パスの開始
      ctx.moveTo(pos.x, pos.y); // パスの開始点を設定
      isDrawing = true; // 描画開始フラグをオン
    });

    // タッチ移動中の処理
    canvas.addEventListener("touchmove", e => {
      if (!isDrawing) return; // 描画中でない場合は何もしない
      const pos = getTouchPos(e); // タッチ位置を取得
      ctx.lineTo(pos.x, pos.y); // パスを現在の位置まで延長
      ctx.stroke(); // 線を描画
    });

    // タッチ終了時の処理
    canvas.addEventListener("touchend", () => {
      isDrawing = false; // 描画終了フラグをオフ
    });
  }
  /**
   * 署名をクリアイベント
   * @param event 
   */
  onClearSignature(): void {
    const canvas = document.getElementById('signatureCanvas') as HTMLCanvasElement;
    const context = canvas.getContext("2d");
    context.clearRect(0, 0, canvas.width, canvas.height);
  }

  /**
   * 料金プラン変更時イベント
   * @param event 
   */
  onPricePlanChange(pricePlan: string) {
    // 電気セット割を除去
    let tempFtiContractList = this.ftiContractListForAll.filter(ftiContract => ("ABC07" != ftiContract.goodsCode));
    // 料金プランが指定されている場合
    if (pricePlan) {
      // 料金プランに応じた画面項目：付帯契約リストを設定
      this.ftiContractList = tempFtiContractList.filter(ftiContract => (pricePlan === ftiContract.prdCode));
      // 料金プラン変更前に表示されていた付帯契約が付帯契約リストに存在する場合
      if (this.ftiContractList.map(ftiContract => ftiContract.goodsCode).includes(this.selectedFtiContract.goodsCode)) {
        // 選択状態を維持
        // 処理なし
      } else {
        // 選択値のクリア
        this.selectedFtiContract.goodsCode = null;
      }
    } else {
      // 料金プランが指定されていない場合
      //　画面項目：付帯契約リストをクリア
      this.ftiContractList = [];
    }
    // 会社コードが西部ガスかつ業種が公団かつ料金プランが床暖房契約（ホットメリット）の場合
    if (Sgkb122dComponent.SAIBU_GAS === this.companycode &&
      Sgkb122dComponent.KOUDAN_LIST.includes(this.hiddenGyoshu) &&
      Sgkb122dComponent.FLOOR_HEATING_CTR === pricePlan) {
      // 公団床暖房の申込書受領を表示する
      this.isVisiblePublicCorporationFloorHeatingSrndocReceipt = true;
      // 公団床暖房の申込書受領を必須チェック対象とする
      this.requiredCheckItemGroup.controls["publicCorporationFloorHeatingSrndocReceipt"].setValidators([Validators.requiredTrue]);
      this.requiredCheckItemGroup.controls["publicCorporationFloorHeatingSrndocReceipt"].updateValueAndValidity();
    } else {
      // 上記以外の場合
      // 公団床暖房の申込書受領を非表示する
      this.isVisiblePublicCorporationFloorHeatingSrndocReceipt = false;
      // 公団床暖房の申込書受領を必須チェック対象外とする
      this.requiredCheckItemGroup.controls["publicCorporationFloorHeatingSrndocReceipt"].clearValidators();
      this.requiredCheckItemGroup.controls["publicCorporationFloorHeatingSrndocReceipt"].updateValueAndValidity();
    }
  }

  /**
   * エラー処理(初期処理用)
   * @memberof Sgkb122dComponent
   */
  errorHandlingForInit(message: string): void {
    // エラーメッセージ設定
    let errorMessageModelForEditArray: Array<SgAriaMessage> = [];
    errorMessageModelForEditArray.push({
      message: message
      , messageClass: "mat-card-background-error"
      , icon: "cancel"
      , iconClass: "mat-icon-color-error"
    });
    this.errorMessageModelArray = errorMessageModelForEditArray;
    //　エラー発生を設定し、登録ボタンを非活性にする
    this.hasError = true;
  }

  /**
  * エラー処理(登録処理用)
  * @memberof Sgkb122dComponent
  */
  errorHandlingForSubmit(messageList: string[]): void {
    // エラーメッセージ設定
    let errorMessageModelForEditArray: Array<SgAriaMessage> = [];
    for (const message of messageList) {
      errorMessageModelForEditArray.push({
        message: message
        , messageClass: "mat-card-background-error"
        , icon: "cancel"
        , iconClass: "mat-icon-color-error"
      });
    }
    this.errorMessageModelArray = errorMessageModelForEditArray;
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
